import {
  InputLabel,
  Divider,
  Typography,
  FormControl,
  Button,
  MenuItem,
  Select,
  Table,
  TableRow,
  TableHead,
  TableCell,
  Dialog,
  TableContainer,
  TableBody
} from "@material-ui/core";
import axios from "axios"
import 'jspdf-autotable'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import FunctionsIcon from '@mui/icons-material/Functions';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import RoomIcon from "@mui/icons-material/Room";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ApartmentIcon from "@mui/icons-material/Apartment";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import BedroomParentIcon from "@mui/icons-material/BedroomParent";
import AttractionsIcon from "@mui/icons-material/Attractions";
import { makeStyles } from "@material-ui/core/styles";
import { useState, useEffect } from "react";
import { fetchQuotebyId, fetchEmployeebyName, uploadsinglefile, updatequoteData, fetchwadata } from "../api/customerapi";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import FlightLandIcon from "@mui/icons-material/FlightLand";
import header2 from "../header2.png";
import accounts3 from "../Accounts3.png";
import accounts2 from "../Accounts2.png";
import footer from "../footer.PNG";
import footer2 from "../footer2.PNG";
import bali1 from "../Bali1.jpg";
import bali2 from "../Bali2.png";
import bali3 from "../Bali3.png";
import singapore1 from "../Singapore1.jpg";
import singapore2 from "../Singapore2.png";
import singapore3 from "../Singapore3.png";
import thailand1 from "../Thailand1.jpg";
import thailand2 from "../Thailand2.png";
import thailand3 from "../Thailand3.png";
import philippines1 from "../Philippines1.jpg";
import philippines2 from "../Philippines2.png";
import philippines3 from "../Philippines3.png";
import dubai1 from "../Dubai1.jpg";
import dubai2 from "../Dubai2.png";
import dubai3 from "../Dubai3.png";
import malaysia1 from "../Malaysia1.jpg";
import malaysia2 from "../Malaysia2.png";
import malaysia3 from "../Malaysia3.png";
import kerala1 from "../Kerala1.jpg";
import kerala2 from "../Kerala2.png";
import kerala3 from "../Kerala3.png";
import maldives1 from "../Maldives1.jpg";
import maldives2 from "../Maldives2.png";
import maldives3 from "../Maldives3.png";
import andaman1 from "../Andaman1.jpg";
import andaman2 from "../Andaman2.png";
import andaman3 from "../Andaman3.png";
import goa1 from "../Goa1.jpg";
import goa2 from "../Goa2.png";
import goa3 from "../Goa3.png";
import kashmir1 from "../Kashmir1.jpg";
import kashmir2 from "../Kashmir2.png";
import kashmir3 from "../Kashmir3.png";
import ladakh1 from "../Ladakh1.jpg";
import ladakh2 from "../Ladakh2.png";
import ladakh3 from "../Ladakh3.png";
import sikkim1 from "../Sikkim1.jpg";
import sikkim2 from "../Sikkim2.png";
import sikkim3 from "../Sikkim3.png";
import srilanka1 from "../Srilanka1.jpg";
import srilanka2 from "../Srilanka2.png";
import srilanka3 from "../Srilanka3.png";
import himachal1 from "../Himachal1.jpg";
import himachal2 from "../Himachal2.png";
import himachal3 from "../Himachal3.png";
import vietnam1 from "../Vietnam1.jpg";
import vietnam2 from "../Vietnam2.png";
import vietnam3 from "../Vietnam3.png";
import mauritius1 from "../Mauritius1.jpg";
import mauritius2 from "../Mauritius2.png";
import mauritius3 from "../Mauritius3.png";
import turkey1 from "../Turkey1.jpg";
import turkey2 from "../Turkey2.png";
import turkey3 from "../Turkey3.png";
import europe1 from "../Europe1.jpg";
import europe2 from "../Europe2.png";
import europe3 from "../Europe3.png";
import hongkong1 from "../HK1.jpg";
import hongkong2 from "../HK2.png";
import hongkong3 from "../HK3.png";
import azerbaijan1 from "../Azerbaijan1.jpg";
import azerbaijan2 from "../Azerbaijan2.png";
import azerbaijan3 from "../Azerbaijan3.png";
import kazakhstan1 from "../Kazakhstan1.jpg";
import kazakhstan2 from "../Kazakhstan2.png";
import kazakhstan3 from "../Kazakhstan3.png";
import rajasthan1 from "../Rajasthan1.png";
import rajasthan2 from "../Rajasthan2.png";
import rajasthan3 from "../Rajasthan3.png";
import georgia1 from "../Georgia1.jpg";
import georgia2 from "../Georgia2.png";
import georgia3 from "../Georgia3.png";
import value from "../value.jpg";
import GetRole from "./user";
import { useAppData } from "./appDataContext.js";
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { identifydestpic, identifydestpic2, identifydestpic3, identifydestpic4} from "./date.js";
import { formatDate2 } from "./date";
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { identifydest} from "./date.js"


const useStyles = makeStyles((theme) => ({
  paper: {
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
  },
  column2: {
    marginLeft: 10,
    width: 200,
  },
  column7: {
    align: "center",
  },
  column4: {
    marginLeft: 10,
    width: 200,
    color: "red",
  },
  para: {
    marginLeft: 50,
    marginTop: 50,
  },
  tablerow: {
    paddingBottom:5,
    paddingTop:5,
    marginTop: 0,
    color: "#a8020b",
    verticalAlign: "middle",
  },
  daypara: {
    marginLeft: 50,
  },
  daypara2: {
    marginLeft: 50,
    width: 690,
  },
  daypara4: {
    marginLeft: 0,

    width: 700,
  },
  tablepara: {
    marginLeft: 5,
    marginTop: 5,
    width: 690,
  },
  table: {
    marginLeft: 100,
    marginTop: 5,
  },
  tablepara2: {
    marginLeft: 0,
    marginTop: 5,
    width: 690,
  },
  column: {
    marginLeft: 50,
    width: 325,
  },
  column3: {
    marginLeft: 10,
    width: 325,
  },
  column6: {
    marginLeft: 0,
    width: 325,
  },
  column8: {
    marginLeft: 0,
    width: 225,
    fontSize:12,
    color: "#a8020b",
  },
  column5: {
    marginLeft: 10,
    width: 600,
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(25),
    height: theme.spacing(6),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  div: {
    backgroundColor: "#f5f5f5",
    width: "210mm",
    minHeight: "297mm",
    marginLeft: "auto",
    marginRight: "auto",
  },
  texttypo: {
    color: "black",
    lineHeight: "75%",
    //font:"Monospace",
  },
  texttypo2: {
    marginTop: 0,
    color: "#a8020b",
    verticalAlign: "middle",
    //font:"Helvetica",
  },
  texttypo2b: {
    marginTop: 0,
    color: "#a8020b",
    verticalAlign: "middle",
    marginLeft:50,
    //font:"Helvetica",
  },
  texttypo6: {
    margin: 0,
    
    verticalAlign: "middle",
    align: "center",
  },
  texttypo9: {
    margin: 0,
    marginLeft:0,
    verticalAlign: "middle",
    align: "center",
  },
  texttypo7: {
    marginLeft: 10,
    fontWeight:900,
    verticalAlign: "middle",
    align: "center",
  },
  texttypo10: {
    marginLeft: 10,
    fontWeight:900,
    verticalAlign: "middle",
    align: "center",
    fontSize:24,
    
  },
  texttypo8: {
    margin: 0,
    fontWeight:700,
    verticalAlign: "middle",
    align: "center",
    color:"white"
  },
  texttypo3: {
    color: "#4f1802",
    marginLeft: 50,
    marginTop: 50,
  },
  texttypo4: {
    color: "black",
    lineHeight: "75%",
    fontSize: 14,
  },
  texttypo5: {
    color: "black",
    lineHeight: "75%",
    fontSize: 12,
  },
  divider1: {
    color: "#a8020b",
    width: "80px",
  },
  icon: {
    align: "center",
    verticalAlign: "middle",
  },
  icon2: {
  
    fontSize:16,
  },
  line: {
    height: 3,
    color:"black",
    backgroundColor: "black",
    
  },
  texttypo11: {
    marginTop: 0,
    color: "#a8020b",
    verticalAlign: "middle",
    marginLeft:50,
    //font:"Helvetica",
  },
  redheadtext: {
    color:"orange"
  },
}));

const theme2 = createTheme({
  typography: {
    allVariants: {
      //fontFamily: "Helvetica Neue",
      //textTransform: "none",
      fontSize: 12,
    },
  },
});

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const Viewquote = () => {
  const classes = useStyles();
  const preURL = document.referrer;
  const currenturl = window.location.href;
  const urlarray = currenturl.split("/");
  const quoteid = urlarray[urlarray.length - 1];
  var { cuser, role } = GetRole();
  const [Open2, setOpen2] = useState(false);
  const [daydata, setdaydata] = useState([]);
  const [flightdata, setflightdata] = useState([]);
  const [walist, setwalist] = useState([]);
  const [tboflightdata, settboflightdata] = useState([]);
  const [eData, seteData] = useState([{}]);
  const [destselect, setdestselect] = useState(false);
  const [filedetails, setfiledetails] = useState(false);
  const [quoteData, setquoteData] = useState({
    favorite: false,
  });
  const [price, setprice] = useState({
    total: 0,
    perperson: 0,
    percnb: 0,
    percwb: 0,
    airfare: 0,
    taxes: 0,
    landprice: 0,
    otheritems: 0,
  });
  const { appData, loading } = useAppData();

  const getQuote = async (id) => {
    try{
    const data = await fetchQuotebyId(id);
    setquoteData(data.data);
    console.log(data.data)
    var t=identifydest(data.data.primary_destination)
    setdestselect(t)
    setdaydata(data.data.day);
    setflightdata(data.data.flight);
    settboflightdata(data.data.tbo_flight);
    setprice(data.data.quote_price);
    const data2 = await fetchEmployeebyName(data.data.trip_owner);
    seteData(data2.data);
    getwa(data.data)
  }catch(err){
    console.log(err)
  }
  };
  var x = 0;
  // const getEmployee = async (id) => {
  //     const data = await fetchEmployeebyName(quoteData.trip_owner);
  //     seteData(data.data)

  // }

  useEffect(() => {
    getQuote(quoteid);
   
  }, []);

  //image pasting
  window.addEventListener("paste", (e) => {
    if (x && e.clipboardData.files.length > 0) {
      // var x=0
      // document.getElementById("#myfile")==null?x=1:x=0
      // document.getElementById("#myfile2")==null?x=2:x=0
      // document.getElementById("#myfile3")==null?x=3:x=0
      console.log(x);
      // const fileInput=document.querySelector("#myfile")
      // fileInput.files=e.clipboardData.files

      if (e.clipboardData.files[0].type.startsWith("image/")) {
       
        setPreviewImage(e.clipboardData.files[0]);
        handleFileInput(e.clipboardData.files[0], x)
        
      }
    }
  });

  function setPreviewImage(file) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    console.log(x)
    console.log(fileReader)
    fileReader.onload = () => {
      if (x == 1) {
        document.querySelector("#imagePreview").src = fileReader.result;
        x=0;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview").src)
      } else if (x == 2) {
        document.querySelector("#imagePreview2").src = fileReader.result;
        x=0;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview2").src)
      } else if (x == 3) {
        document.querySelector("#imagePreview3").src = fileReader.result;
        x=0;
        // console.log(image.imagenumber)
        // console.log(document.querySelector("#imagePreview3").src)
      }
    };
  }
  const removeimage = (e) => {
    //console.log(e.target.innerHTML)
    var temp=[]
    if (e.target.innerHTML == "Remove Image 1") {
      document.querySelector("#imagePreview").src = "abc";

      x = 0;
      temp=filedetails.filter(data=>data.name !==1)
      setfiledetails(temp)
    } else if (e.target.innerHTML == "Remove Image 2") {
      document.querySelector("#imagePreview2").src = "abc";

      x = 0;
      temp=filedetails.filter(data=>data.name !==2)
      setfiledetails(temp)
    } else if (e.target.innerHTML == "Remove Image 3") {
      document.querySelector("#imagePreview3").src = "abc";

      x = 0;
      temp=filedetails.filter(data=>data.name !==3)
      setfiledetails(temp)
    }
  };

  const savepdf2 = () => {
    let pdf = new jsPDF();
    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);

        const initial = document.getElementById("1header");
        html2canvas(initial).then((canvas) => {
          const initialdata = canvas.toDataURL("image/jpeg", 0.5);
          pdf.addImage(imgHeader, "JPEG", 0, 0);
          pdf.addImage(initialdata, "JPEG", 0, 45);
          pdf.addImage(imgFooter, "JPEG", 0, 235);
          const imgdata1 = document.getElementById("image1");
          html2canvas(imgdata1).then((canvas) => {
            const imgdata1data = canvas.toDataURL("image/jpeg", 0.5);
            const imgdata2 = document.getElementById("imagePreview2");
            html2canvas(imgdata2).then((canvas) => {
              const imgdata2data = canvas.toDataURL("image/jpeg", 0.5);
              const imgdata3 = document.getElementById("imagePreview3");
              html2canvas(imgdata3).then((canvas) => {
                const imgdata3data = canvas.toDataURL("image/jpeg", 0.5);
                pdf.addPage();
                pdf.addImage(imgdata1data, "JPEG", 20, 5);
                pdf.addImage(imgdata2data, "JPEG", 20, 105);
                pdf.addImage(imgdata3data, "JPEG", 20, 205);
                for (let i = 0; i < daydata.length; i++) {
                  const day = document.getElementById(i);
                  html2canvas(day).then((canvas) => {
                    const imgData = canvas.toDataURL("image/jpeg", 0.5);
                    pdf.addPage();
                    pdf.addImage(imgHeader, "JPEG", 0, 0);
                    pdf.addImage(imgData, "JPEG", 0, 45);
                    pdf.addImage(imgFooter, "JPEG", 0, 235);
                  });
                }
                const details = document.getElementById("2details");
                html2canvas(details).then((canvas) => {
                  const imgData = canvas.toDataURL("image/jpeg", 0.5);
                  pdf.addPage();
                  pdf.addImage(imgHeader, "JPEG", 0, 0);
                  pdf.addImage(imgData, "JPEG", 0, 45);
                  pdf.addImage(imgFooter, "JPEG", 0, 235);
                  const account = document.getElementById("3account");
                  html2canvas(account).then((canvas) => {
                    const imgData = canvas.toDataURL("image/jpeg", 0.5);
                    pdf.addPage();
                    pdf.addImage(imgHeader, "JPEG", 0, 0);
                    pdf.addImage(imgData, "JPEG", 0, 45);
                    pdf.addImage(imgFooter, "JPEG", 0, 235);
                    const endnotes = document.getElementById("endnotes");
                    html2canvas(endnotes).then((canvas) => {
                      const imgData = canvas.toDataURL("image/jpeg", 0.5);
                      pdf.addPage();
                      pdf.addImage(imgHeader, "JPEG", 0, 0);
                      pdf.addImage(imgData, "JPEG", 0, 45);
                      pdf.addImage(imgFooter, "JPEG", 0, 235);
                      const tnc = document.getElementById("tnc");
                      html2canvas(tnc).then((canvas) => {
                        const imgData = canvas.toDataURL("image/jpeg", 0.5);
                        pdf.addPage();
                        pdf.addImage(imgHeader, "JPEG", 0, 0);
                        pdf.addImage(imgData, "JPEG", 0, 45);
                        pdf.addImage(imgFooter, "JPEG", 0, 235);
                        const tnc2 = document.getElementById("tnc2");
                        html2canvas(tnc2).then((canvas) => {
                          const imgData = canvas.toDataURL("image/jpeg", 0.5);
                          pdf.addPage();
                          pdf.addImage(imgHeader, "JPEG", 0, 0);
                          pdf.addImage(imgData, "JPEG", 0, 45);
                          pdf.addImage(imgFooter, "JPEG", 0, 235);

                          pdf.save(
                            quoteData.cust_name +
                              "_" +
                              quoteData.primary_destination +
                              "_" +
                              quoteData.quote_id
                          );
                          //pdf.output('dataurlnewwindow');
                        });
                      });
                    });
                  });
                });
              });
            });
          });
        });
        //pdf.save("download.pdf");
        //pdf.output('dataurlnewwindow');
        //<p align="center">|------------------------------------------------JETO VACATIONS---------------------------------------------|</p>
      });
    });
  };

  const savepdf = () => {
    let pdf = new jsPDF();
    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);

        const initial = document.getElementById("1header");
        html2canvas(initial).then((canvas) => {
          const initialdata = canvas.toDataURL("image/jpeg", 0.5);
          const flight = document.getElementById("flight");
          html2canvas(flight).then((canvas) => {
            const flightdata = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addImage(imgHeader, "JPEG", 0, 0);
            pdf.addImage(initialdata, "JPEG", 0, 45);
            pdf.addImage(flightdata, "JPEG", 0, 135);
            pdf.addImage(imgFooter, "JPEG", 0, 235);

            for (let i = 0; i < daydata.length; i++) {
              const day = document.getElementById(i);
              html2canvas(day).then((canvas) => {
                const imgData = canvas.toDataURL("image/jpeg", 0.7);
                pdf.addPage();
                pdf.addImage(imgHeader, "JPEG", 0, 0);
                pdf.addImage(imgData, "JPEG", 0, 45);
                pdf.addImage(imgFooter, "JPEG", 0, 235);
              });
            }
            const details = document.getElementById("2details");
            html2canvas(details).then((canvas) => {
              const imgData = canvas.toDataURL("image/jpeg", 0.5);
              pdf.addPage();
              pdf.addImage(imgHeader, "JPEG", 0, 0);
              pdf.addImage(imgData, "JPEG", 0, 45);
              pdf.addImage(imgFooter, "JPEG", 0, 235);
              const account = document.getElementById("3account");
              html2canvas(account).then((canvas) => {
                const imgData = canvas.toDataURL("image/jpeg", 0.5);
                pdf.addPage();
                pdf.addImage(imgHeader, "JPEG", 0, 0);
                pdf.addImage(imgData, "JPEG", 0, 45);
                pdf.addImage(imgFooter, "JPEG", 0, 235);
                const endnotes = document.getElementById("endnotes");
                html2canvas(endnotes).then((canvas) => {
                  const imgData = canvas.toDataURL("image/jpeg", 0.5);
                  pdf.addPage();
                  pdf.addImage(imgHeader, "JPEG", 0, 0);
                  pdf.addImage(imgData, "JPEG", 0, 45);
                  pdf.addImage(imgFooter, "JPEG", 0, 235);
                  const tnc = document.getElementById("tnc");
                  html2canvas(tnc).then((canvas) => {
                    const imgData = canvas.toDataURL("image/jpeg", 0.5);
                    pdf.addPage();
                    pdf.addImage(imgHeader, "JPEG", 0, 0);
                    pdf.addImage(imgData, "JPEG", 0, 45);
                    pdf.addImage(imgFooter, "JPEG", 0, 235);
                    const tnc2 = document.getElementById("tnc2");
                    html2canvas(tnc2).then((canvas) => {
                      const imgData = canvas.toDataURL("image/jpeg", 0.5);
                      pdf.addPage();
                      pdf.addImage(imgHeader, "JPEG", 0, 0);
                      pdf.addImage(imgData, "JPEG", 0, 45);
                      pdf.addImage(imgFooter, "JPEG", 0, 235);

                      pdf.save(
                        quoteData.cust_name +
                          "_" +
                          quoteData.primary_destination +
                          "_" +
                          quoteData.quote_id
                      );
                      //pdf.output('dataurlnewwindow');
                    });
                  });
                });
              });
            });
          });
        });
        //pdf.save("download.pdf");
        //pdf.output('dataurlnewwindow');
        //<p align="center">|------------------------------------------------JETO VACATIONS---------------------------------------------|</p>
      });
    });
  };

  const delay = (ms) => new Promise((res) => setTimeout(res, ms));

  const savepdf4 = () => {
    let pdf = new jsPDF();
    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
        const footer2 = document.getElementById("imgfooter2");
        html2canvas(footer2).then((canvas) => {
          const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
        const initial = document.getElementById("1header");
        html2canvas(initial).then((canvas) => {
          const initialdata = canvas.toDataURL("image/jpeg", 0.5);
          pdf.addImage(imgHeader, "JPEG", 0, 0);
          pdf.addImage(initialdata, "JPEG", 0, 45);
          pdf.addImage(imgFooter, "JPEG", 0, 235);
          const imgdata1 = document.getElementById("image1");
          html2canvas(imgdata1).then((canvas) => {
            const imgdata1data = canvas.toDataURL("image/jpeg", 0.5);
            const imgdata2 = document.getElementById("imagePreview2");
            html2canvas(imgdata2).then((canvas) => {
              const imgdata2data = canvas.toDataURL("image/jpeg", 0.5);
              const imgdata3 = document.getElementById("imagePreview3");
              html2canvas(imgdata3).then((canvas) => {
                const imgdata3data = canvas.toDataURL("image/jpeg", 0.5);
                pdf.addPage();
                pdf.addImage(imgdata1data, "JPEG", 20, 5);
                pdf.addImage(imgdata2data, "JPEG", 20, 105);
                pdf.addImage(imgdata3data, "JPEG", 20, 205);
                for (let i = 0; i < daydata.length; i++) {
                  const day = document.getElementById(i);
                  html2canvas(day).then((canvas) => {
                    const imgData = canvas.toDataURL("image/jpeg", 0.5);
                    pdf.addPage();
                    pdf.addImage(imgHeader, "JPEG", 0, 0);
                    pdf.addImage(imgData, "JPEG", 0, 45);
                    pdf.addImage(imgFooter, "JPEG", 0, 235);
                    console.log(i);
                    if (i == daydata.length - 1) {
                      part2(imgHeader, imgFooter, imgFooter2, pdf);
                    }
                  });
                }
                // const details = document.getElementById("2details");
                // html2canvas(details).then((canvas) => {
                //   const imgData = canvas.toDataURL("image/jpeg", 0.5);
                //   pdf.addPage();
                //   pdf.addImage(imgHeader, "JPEG", 0, 0);
                //   pdf.addImage(imgData, "JPEG", 0, 45);
                //   pdf.addImage(imgFooter, "JPEG", 0, 235);
                //   const account = document.getElementById("3account");
                //   html2canvas(account).then((canvas) => {
                //     const imgData = canvas.toDataURL("image/jpeg", 0.5);
                //     pdf.addPage();
                //     pdf.addImage(imgHeader, "JPEG", 0, 0);
                //     pdf.addImage(imgData, "JPEG", 0, 45);
                //     pdf.addImage(imgFooter, "JPEG", 0, 235);
                //     const endnotes = document.getElementById("endnotes");
                //     html2canvas(endnotes).then((canvas) => {
                //       const imgData = canvas.toDataURL("image/jpeg", 0.5);
                //       pdf.addPage();
                //       pdf.addImage(imgHeader, "JPEG", 0, 0);
                //       pdf.addImage(imgData, "JPEG", 0, 45);
                //       pdf.addImage(imgFooter, "JPEG", 0, 235);
                //       const tnc = document.getElementById("tnc");
                //       html2canvas(tnc).then((canvas) => {
                //         const imgData = canvas.toDataURL("image/jpeg", 0.5);
                //         pdf.addPage();
                //         pdf.addImage(imgHeader, "JPEG", 0, 0);
                //         pdf.addImage(imgData, "JPEG", 0, 45);
                //         pdf.addImage(imgFooter, "JPEG", 0, 235);
                //         const tnc2 = document.getElementById("tnc2");
                //         html2canvas(tnc2).then((canvas) => {
                //           const imgData = canvas.toDataURL("image/jpeg", 0.5);
                //           pdf.addPage();
                //           pdf.addImage(imgHeader, "JPEG", 0, 0);
                //           pdf.addImage(imgData, "JPEG", 0, 45);
                //           pdf.addImage(imgFooter, "JPEG", 0, 235);

                //           pdf.save(
                //             quoteData.cust_name +
                //               "_" +
                //               quoteData.primary_destination +
                //               "_" +
                //               quoteData.quote_id
                //           );
                //           //pdf.output('dataurlnewwindow');
                //         });
                //       });
                //     });
                // });
                });
              });
            });
          });
        });
        //pdf.save("download.pdf");
        //pdf.output('dataurlnewwindow');
        //<p align="center">|------------------------------------------------JETO VACATIONS---------------------------------------------|</p>
      });
    });
  };

  const choosepdf = () => {
    if (flightdata.length > 4) {
      savepdf5();
    } else {
      savepdf3();
    }
  };

  const savepdf5 = () => {
    //let count=0
    let pdf = new jsPDF();
    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
        const footer2 = document.getElementById("imgfooter2");
        html2canvas(footer2).then((canvas) => {
          const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
          const initial = document.getElementById("1header");
          html2canvas(initial).then((canvas) => {
            const initialdata = canvas.toDataURL("image/jpeg", 0.5);
            const flight = document.getElementById("flight");
            html2canvas(flight).then((canvas) => {
              const flightdata = canvas.toDataURL("image/jpeg", 0.5);
              pdf.addImage(imgHeader, "JPEG", 0, 0);
              pdf.addImage(initialdata, "JPEG", 0, 45);
              //
              pdf.addImage(imgFooter, "JPEG", 0, 235);
              pdf.addPage();
              pdf.addImage(imgHeader, "JPEG", 0, 0);
              pdf.addImage(flightdata, "JPEG", 0, 40);
              pdf.addImage(imgFooter2, "JPEG", 0, 280);

              for (let i = 0; i < daydata.length; i++) {
                const day = document.getElementById(i);
                html2canvas(day).then((canvas) => {
                  const imgData = canvas.toDataURL("image/jpeg", 0.7);
                  pdf.addPage();
                  pdf.addImage(imgHeader, "JPEG", 0, 0);
                  pdf.addImage(imgData, "JPEG", 0, 45);
                  pdf.addImage(imgFooter, "JPEG", 0, 235);
                  console.log(i);
                  if (i == daydata.length - 1) {
                    part2(imgHeader, imgFooter, pdf);
                  } //count++
                });
              }
            });
          });
        });
      });
    });
    // });
  };

  const savepdf3 = () => {
    let options = {
      orientation: "p",
      unit: "mm",
      format: "a4",
      //putOnlyUsedFonts: true,
    };
    //default is width 210, height 297
    let pdf = new jsPDF(options);
    var width = pdf.internal.pageSize.getWidth();

    const header = document.getElementById("imgheader");
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById("imgfooter");
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
        const footer2 = document.getElementById("imgfooter2");
        html2canvas(footer2).then((canvas) => {
          const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
          const initial = document.getElementById("1header");
          html2canvas(initial).then((canvas) => {
            const initialdata = canvas.toDataURL("image/jpeg", 0.5);
            const flight = document.getElementById("flight");
            html2canvas(flight).then((canvas) => {
              const flightdata = canvas.toDataURL("image/jpeg", 0.5);
              // const imgProps1= pdf.getImageProperties(imgHeader);
              // const pdfHeight1 = (imgProps1.height * width) / imgProps1.width;
              pdf.addImage(imgHeader, "JPEG", 0, 0);
              pdf.addImage(initialdata, "JPEG", 0, 45);
              pdf.addImage(flightdata, "JPEG", 0, 110);
              pdf.addImage(imgFooter2, "JPEG", 0, 280);
              //count++

              for (let i = 0; i < daydata.length; i++) {
                const day = document.getElementById(i);
                html2canvas(day).then((canvas) => {
                  const imgData = canvas.toDataURL("image/jpeg", 0.7);
                  pdf.addPage();
                  //pdf.addImage(imgFooter, "JPEG", 0, 0);
                  pdf.addImage(imgHeader, "JPEG", 0, 0);
                  pdf.addImage(imgData, "JPEG", 0, 45);
                  pdf.addImage(imgFooter, "JPEG", 0, 235);
                  console.log(i);
                  if (i == daydata.length - 1) {
                    part2(imgHeader, imgFooter, imgFooter2, pdf);
                  } //count++
                });
              }
            });
          });
        });
      });
    });
    // });
  };

  const part2 = (imgHeader, imgFooter, imgFooter2, pdf) => {
    // var width = pdf.internal.pageSize.getWidth();
    // var height = pdf.internal.pageSize.getHeight();
    const details = document.getElementById("2details");
    html2canvas(details).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.5);
      pdf.addPage();
      pdf.addImage(imgHeader, "JPEG", 0, 0);
      pdf.addImage(imgData, "JPEG", 0, 45);
      pdf.addImage(imgFooter, "JPEG", 0, 235);
      const details2 = document.getElementById("2bdetails");
      html2canvas(details2).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.5);
        pdf.addPage();
        pdf.addImage(imgHeader, "JPEG", 0, 0);
        pdf.addImage(imgData, "JPEG", 0, 45);
        pdf.addImage(imgFooter, "JPEG", 0, 235);
      const account = document.getElementById("3account");
      html2canvas(account).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 0.5);
        pdf.addPage();
        pdf.autoTable({ html: '#withoutdiscount' })
        pdf.addImage(imgHeader, "JPEG", 0, 0);
        pdf.addImage(imgData, "JPEG", 0, 45);
        // pdf.addImage(imgFooter, "JPEG", 0, 235);
        if (quoteData && quoteData.option2) {
          const option2 = document.getElementById("option2");
          html2canvas(option2).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addPage();
            pdf.addImage(imgHeader, "JPEG", 0, 0);
            pdf.addImage(imgData, "JPEG", 0, 35);
            //pdf.addImage(imgFooter, "JPEG", 0, 235);
          });
        }
        if (quoteData && quoteData.option3) {
          const option3 = document.getElementById("option3");
          html2canvas(option3).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addPage();
            pdf.addImage(imgHeader, "JPEG", 0, 0);
            pdf.addImage(imgData, "JPEG", 0, 35, 210, 240);
            //pdf.addImage(imgFooter, "JPEG", 0, 235);
          });
        }
        const endnotes = document.getElementById("endnotes");
        html2canvas(endnotes).then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg", 0.5);
          pdf.addPage();
          pdf.addImage(imgHeader, "JPEG", 0, 0);
          pdf.addImage(imgData, "JPEG", 0, 45);
          pdf.addImage(imgFooter2, "JPEG", 0, 280);
          const tnc = document.getElementById("tnc");
          html2canvas(tnc).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addPage();
            pdf.addImage(imgHeader, "JPEG", 0, 0);
            pdf.addImage(imgData, "JPEG", 0, 45);
            pdf.addImage(imgFooter2, "JPEG", 0, 280);
            const tnc2 = document.getElementById("tnc2");
            html2canvas(tnc2).then((canvas) => {
              const imgData = canvas.toDataURL("image/jpeg", 0.5);
              pdf.addPage();
              pdf.addImage(imgHeader, "JPEG", 0, 0);
              pdf.addImage(imgData, "JPEG", 0, 45);
              pdf.addImage(imgFooter2, "JPEG", 0, 280);
              pdf.save(
                quoteData.cust_name +
                  "_" +
                  quoteData.primary_destination +
                  "_" +
                  quoteData.quote_id
              );
            });
          });
        });
      });
    });
  })
  };

  const newpdf2 = (bodyimage, pdf) => {
   //console.log(pdf)
    const pic4 = identifydestpic4(quoteData.primary_destination);
    const details = document.getElementById("2details");
    html2canvas(details).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.5);
      pdf.addPage();
      pdf.addImage(bodyimage, "JPEG", 0, 0);
      pdf.addImage(imgData, "JPEG", 0, 45);
      const details2 = document.getElementById("2bdetails");
      html2canvas(details2).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1);
        pdf.addPage();
        pdf.addImage(bodyimage, "JPEG", 0, 0);
        pdf.addImage(imgData, "JPEG", 0, 45);
        const account2 = document.getElementById("3caccount");
        html2canvas(account2).then((canvas) => { 
          const imgData2 = canvas.toDataURL("image/jpeg", 1);
      const account = document.getElementById("3baccount");
      html2canvas(account).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1);
        pdf.addPage();
        pdf.addImage(bodyimage, "JPEG", 0, 0);
        pdf.addImage(imgData, "JPEG", 0, 40, 210, 240);
        pdf.addImage(imgData2, "JPEG", 130, 40);
        if (quoteData.primary_destination=="Indonesia") {
          const details4 = document.getElementById(pic4);
          html2canvas(details4).then((canvas) => {
            const imgData5 = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addPage();
          pdf.addImage(bodyimage, "JPEG", 0, 0);
          pdf.addImage(imgData5, "JPEG", 10, 40, 190, 240);
          })
        }
        
       
        if (quoteData && quoteData.option2) {
          const option2 = document.getElementById("option2");
          html2canvas(option2).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addPage();
            pdf.addImage(bodyimage, "JPEG", 0, 0);
            pdf.addImage(imgData, "JPEG", 0, 35, 210, 240);
            //pdf.addImage(imgFooter, "JPEG", 0, 235);
          });
        }
        if (quoteData && quoteData.option3) {
          const option3 = document.getElementById("option3");
          html2canvas(option3).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.5);
            pdf.addPage();
            pdf.addImage(bodyimage, "JPEG", 0, 0);
            pdf.addImage(imgData, "JPEG", 0, 35, 210, 240);
            //pdf.addImage(imgFooter, "JPEG", 0, 235);
          });
        }
        const endnotes = document.getElementById("endnotes");
        html2canvas(endnotes).then((canvas) => {
          const imgData = canvas.toDataURL("image/jpeg", 0.7);
          pdf.addPage();
          pdf.addImage(bodyimage, "JPEG", 0, 0);
          pdf.addImage(imgData, "JPEG", 0, 45);
          //pdf.addImage(imgFooter, "JPEG", 0, 235);
          const tnc = document.getElementById("tnc");
          html2canvas(tnc).then((canvas) => {
            const imgData = canvas.toDataURL("image/jpeg", 0.7);
            pdf.addPage();
            pdf.addImage(bodyimage, "JPEG", 0, 0);
            pdf.addImage(imgData, "JPEG", 0, 45);
            //pdf.addImage(imgFooter, "JPEG", 0, 235);
            const tnc2 = document.getElementById("tnc2");
            html2canvas(tnc2).then((canvas) => {
              const imgData = canvas.toDataURL("image/jpeg", 0.7);
              pdf.addPage();
              pdf.addImage(bodyimage, "JPEG", 0, 0);
              pdf.addImage(imgData, "JPEG", 0, 45);
              //pdf.addImage(imgFooter, "JPEG", 0, 235);
              pdf.save(
                quoteData.cust_name +
                  "_" +
                  quoteData.primary_destination +
                  "_" +
                  quoteData.quote_id
              );
            });
          })
         
        });
      });
    });
  })
})
//  pdf.save(
//                 quoteData.cust_name +
//                   "_" +
//                   quoteData.primary_destination +
//                   "_" +
//                   quoteData.quote_id
//               );
  };

  const newpdf1 = () => {
    let options = {
      orientation: "p",
      unit: "mm",
      format: "a4",
      putOnlyUsedFonts: true,
    };
    let pdf = new jsPDF(options);
    const pic = identifydestpic(quoteData.primary_destination);
    const pic2 = identifydestpic2(quoteData.primary_destination);
    const pic3 = identifydestpic3(quoteData.primary_destination);
    // alert(pic)
    // alert(pic2)
    //  alert(pic3)
    const header = document.getElementById(pic);
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById(pic3);
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 1);
        const footer2 = document.getElementById("imgfooter2");
        html2canvas(footer2).then((canvas) => {
          const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
          const initial = document.getElementById("1header");
          html2canvas(initial).then((canvas) => {
            const initialdata = canvas.toDataURL("image/jpeg", 0.5);
            const flight = document.getElementById("flight");
            html2canvas(flight).then((canvas) => {
              const flightdata = canvas.toDataURL("image/jpeg", 0.5);
              const body = document.getElementById(pic2);
              html2canvas(body).then((canvas) => {
                const bodyimage = canvas.toDataURL("image/jpeg", 0.5);
                // const imgProps1= pdf.getImageProperties(imgHeader);
                // const pdfHeight1 = (imgProps1.height * width) / imgProps1.width;
                pdf.addImage(imgHeader, "JPEG", 0, 0);
                pdf.addImage(initialdata, "JPEG", 0, 45);
                
                // pdf.addImage(flightdata, "JPEG", 0, 110);
                // pdf.addImage(imgFooter2, "JPEG", 0, 280);
                //count++
//newpdf2(bodyimage, pdf);
                for (let i = 0; i < daydata.length; i++) {
                  const day = document.getElementById(i);
                  html2canvas(day).then((canvas) => {
                    pdf.addPage();
                    const imgData = canvas.toDataURL("image/jpeg", 0.7);
                    const imgProps1 = pdf.getImageProperties(imgData);

                    //alert(imgProps1.height)
                    pdf.addImage(bodyimage, "JPEG", 0, 0);
                    pdf.addImage(imgData, "JPEG", 0, 40);
                    //pdf.addImage(imgFooter, "JPEG", 20, 650);
                    if (imgProps1.height < 600) {
                      pdf.addImage(imgFooter, "JPEG", 0, 200);
                    }

                    if (i == daydata.length - 1) {
              
                      newpdf2(bodyimage, pdf);
                    } //count++
                  });
                }
              });
            });
          });
        });
      });
    });
    
    //newpdf2(bodyimage, pdf);
  };

  const newpdf1test = () => {
    let options = {
      orientation: "p",
      unit: "mm",
      format: "a4",
      putOnlyUsedFonts: true,
    };
    let pdf = new jsPDF(options);
    const pic = identifydestpic(quoteData.primary_destination);
    const pic2 = identifydestpic2(quoteData.primary_destination);
    const pic3 = identifydestpic3(quoteData.primary_destination);
    // alert(pic)
    // alert(pic2)
    //  alert(pic3)
    
    const header = document.getElementById(pic);
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      // const footer = document.getElementById(pic3);
      // html2canvas(footer).then((canvas) => {
      //   const imgFooter = canvas.toDataURL("image/jpeg", 1);
      //   const footer2 = document.getElementById("imgfooter2");
      //   html2canvas(footer2).then((canvas) => {
      //     const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
          const initial = document.getElementById("1header");
          html2canvas(initial).then((canvas) => {
            const initialdata = canvas.toDataURL("image/jpeg", 0.5);
            const flight = document.getElementById("flight");
            // html2canvas(flight).then((canvas) => {
            //   const flightdata = canvas.toDataURL("image/jpeg", 0.5);
            //   const body = document.getElementById(pic2);
            //   html2canvas(body).then((canvas) => {
            //     const bodyimage = canvas.toDataURL("image/jpeg", 0.5);
                // const imgProps1= pdf.getImageProperties(imgHeader);
                // const pdfHeight1 = (imgProps1.height * width) / imgProps1.width;
                pdf.addImage(imgHeader, "JPEG", 0, 0);
                pdf.addImage(initialdata, "JPEG", 0, 45);
                pdf.save(quoteData.cust_name +"_" +quoteData.primary_destination +"_" +quoteData.quote_id);
                // pdf.addImage(flightdata, "JPEG", 0, 110);
                // pdf.addImage(imgFooter2, "JPEG", 0, 280);
                //count++
//newpdf2(bodyimage, pdf);
              //   for (let i = 0; i < daydata.length; i++) {
              //     const day = document.getElementById(i);
              //     html2canvas(day).then((canvas) => {
              //       pdf.addPage();
              //       const imgData = canvas.toDataURL("image/jpeg", 0.7);
              //       const imgProps1 = pdf.getImageProperties(imgData);

              //       //alert(imgProps1.height)
              //       pdf.addImage(bodyimage, "JPEG", 0, 0);
              //       pdf.addImage(imgData, "JPEG", 0, 40);
              //       //pdf.addImage(imgFooter, "JPEG", 20, 650);
              //       if (imgProps1.height < 600) {
              //         pdf.addImage(imgFooter, "JPEG", 0, 200);
              //       }

              //       if (i == daydata.length - 1) {
              // //          pdf.save(
              // //   quoteData.cust_name +
              // //     "_" +
              // //     quoteData.primary_destination +
              // //     "_" +
              // //     quoteData.quote_id
              // // );
              //         newpdf2(bodyimage, pdf);
              //       } //count++
              //     });
              //   }
        //       });
        //     });
        //   });
        // });
      });
    });
    
    //newpdf2(bodyimage, pdf);
  };
  const newpdf3 = () => {
    let options = {
      orientation: "p",
      unit: "mm",
      format: "a4",
      putOnlyUsedFonts: true,
    };
    let options2 = {
      orientation: "p",
      unit: "mm",
      format: "a3",
      putOnlyUsedFonts: true,
    };
    //default is width 210, height 297
    let pdf = new jsPDF(options);
    const pic = identifydestpic(quoteData.primary_destination);
    const pic2 = identifydestpic2(quoteData.primary_destination);
    const pic3 = identifydestpic3(quoteData.primary_destination);
    //alert(pic3)
    const header = document.getElementById(pic);
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById(pic3);
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 0.5);
        const footer2 = document.getElementById("imgfooter2");
        html2canvas(footer2).then((canvas) => {
          const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
          const initial = document.getElementById("1header");
          html2canvas(initial).then((canvas) => {
            const initialdata = canvas.toDataURL("image/jpeg", 0.5);
            const flight = document.getElementById("flight");
            html2canvas(flight).then((canvas) => {
              const flightdata = canvas.toDataURL("image/jpeg", 0.5);
              const body = document.getElementById(pic2);
              html2canvas(body).then((canvas) => {
                const bodyimage = canvas.toDataURL("image/jpeg", 0.5);
                // const imgProps1= pdf.getImageProperties(imgHeader);
                // const pdfHeight1 = (imgProps1.height * width) / imgProps1.width;
                pdf.addImage(imgHeader, "JPEG", 0, 0);
                pdf.addImage(initialdata, "JPEG", 0, 45);
                const imgdata1 = document.getElementById("image1");
                html2canvas(imgdata1).then((canvas) => {
                  const imgdata1data = canvas.toDataURL("image/jpeg", 0.7);
                  const imgdata2 = document.getElementById("imagePreview2");
                  html2canvas(imgdata2).then((canvas) => {
                    const imgdata2data = canvas.toDataURL("image/jpeg", 0.7);
                    const imgdata3 = document.getElementById("imagePreview3");
                    html2canvas(imgdata3).then((canvas) => {
                      const imgdata3data = canvas.toDataURL("image/jpeg", 0.7);
                      pdf.addPage();
                      pdf.addImage(imgdata1data, "JPEG", 20, 15);
                      pdf.addImage(imgdata2data, "JPEG", 20, 110);
                      pdf.addImage(imgdata3data, "JPEG", 20, 205);

                      for (let i = 0; i < daydata.length; i++) {
                        const day = document.getElementById(i);
                        html2canvas(day).then((canvas) => {
                          //canvas.width =500
                          const imgData = canvas.toDataURL("image/jpeg", 0.7);
                          const imgProps1 = pdf.getImageProperties(imgData);
                          pdf.addPage(options2);
                          //pdf.addImage(imgFooter, "JPEG", 0, 0);
                          pdf.addImage(bodyimage, "JPEG", 0, 0);
                          pdf.addImage(imgData, "JPEG", 0, 40);
                          if (imgProps1.height < 625) {
                            pdf.addImage(imgFooter, "JPEG", 0, 200);
                          }
                          if (i == daydata.length - 1) {
                            newpdf2(bodyimage, pdf);
                          } //count++
                        });
                      }
                    });
                  });
                });
              });
            });
          });
        });
      });
    });
  };

  const newpdf4 = () => {
    let options = {
      orientation: "p",
      unit: "mm",
      format: "a4",
      putOnlyUsedFonts: true,
    };
    let pdf = new jsPDF(options);
    const pic = identifydestpic(quoteData.primary_destination);
    const pic2 = identifydestpic2(quoteData.primary_destination);
    const pic3 = identifydestpic3(quoteData.primary_destination);
    // alert(pic)
    // alert(pic2)
    const header = document.getElementById(pic);
    html2canvas(header).then((canvas) => {
      const imgHeader = canvas.toDataURL("image/jpeg", 0.5);
      const footer = document.getElementById(pic3);
      html2canvas(footer).then((canvas) => {
        const imgFooter = canvas.toDataURL("image/jpeg", 1);
        const footer2 = document.getElementById("imgfooter2");
        html2canvas(footer2).then((canvas) => {
          const imgFooter2 = canvas.toDataURL("image/jpeg", 0.5);
          const initial = document.getElementById("1header");
          html2canvas(initial).then((canvas) => {
            const initialdata = canvas.toDataURL("image/jpeg", 0.5);
            const flight = document.getElementById("flight3");
            html2canvas(flight).then((canvas) => {
              const flightdata = canvas.toDataURL("image/jpeg", 0.5);
              const body = document.getElementById(pic2);
              html2canvas(body).then((canvas) => {
                const bodyimage = canvas.toDataURL("image/jpeg", 0.5);
                // const imgProps1= pdf.getImageProperties(imgHeader);
                // const pdfHeight1 = (imgProps1.height * width) / imgProps1.width;
                pdf.addImage(imgHeader, "JPEG", 0, 0);
                pdf.addImage(initialdata, "JPEG", 0, 45);
                pdf.addPage();
                pdf.addImage(bodyimage, "JPEG", 0, 0);
                pdf.addImage(flightdata, "JPEG", 0, 40);
                // pdf.addImage(flightdata, "JPEG", 0, 110);
                // pdf.addImage(imgFooter2, "JPEG", 0, 280);
                //count++

                for (let i = 0; i < daydata.length; i++) {
                  const day = document.getElementById(i);
                  html2canvas(day).then((canvas) => {
                    pdf.addPage();
                    const imgData = canvas.toDataURL("image/jpeg", 0.7);
                    const imgProps1 = pdf.getImageProperties(imgData);

                    //alert(imgProps1.height)
                    pdf.addImage(bodyimage, "JPEG", 0, 0);
                    pdf.addImage(imgData, "JPEG", 0, 40);
                    //pdf.addImage(imgFooter, "JPEG", 20, 650);
                    if (imgProps1.height < 600) {
                      pdf.addImage(imgFooter, "JPEG", 0, 200);
                    }

                    if (i == daydata.length - 1) {
                      newpdf2(bodyimage, pdf);
                    } //count++
                  });
                }
              });
            });
          });
        });
      });
    });
  };

  const downpdf=async() => {
    let id={id:quoteid}
    //const getpdfResponse = await fetchPDFbyId(id);
    //const getpdfResponse = await fetch("https://jetovacations.in"+"/genserverpdf", {
        const getpdfResponse = await fetch("http://localhost:5000"+"/genserverpdf", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(id),
          });
  
         console.log(getpdfResponse.body)
  
          getpdfResponse.blob().then(blob => showInOtherTab(blob))
    
  }
  
    function showInOtherTab(blob) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = quoteData.cust_name +
      "_" +
      quoteData.primary_destination +
      "_" +
      quoteData.quote_id+".pdf";
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove()
    }
    
    const openlink=()=>{
      window.open("https://www.jetovacations.com/quote/"+quoteData._id, "_blank")
    }

    const handleFileInput = (file, number) => {
      //console.log(file)
      const formdata=new FormData()
      formdata.append("myFile",file,file.name)
      if(filedetails){
        setfiledetails([...filedetails, {name:number, data:formdata}]);
      }else{
        setfiledetails([{name:number, data:formdata}]);
      }
    }

    
const uploadfile=async()=>{
  console.log(filedetails)
  var location=[]
  try{
    for(let i=0; i<filedetails.length; i++){
      const data=await uploadsinglefile(filedetails[i].data)
      //console.log(data.data)
        // if(data.data.name){
        //   alert("File "+data.data.name+" uploaded succesfully")
        // }else{
        //   alert("Error while uploading")
        // }
        const temp={
          location:data.data.location,
          name:data.data.name,
          uploadtime:new Date(),
        }
        location=[...location, temp]
    }
    console.log(location)
    if(location.length==filedetails.length){
      alert("All files uploaded successfully")
    }
    //setquoteData({...quoteData, filelocation:location})
    const finalquoteData={...quoteData, filelocation:location}
    console.log(finalquoteData)
    const updateQuoteResponse= await updatequoteData(finalquoteData._id,finalquoteData);
        
        if(updateQuoteResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Quote updated for trip with trip id "+updateQuoteResponse.data.trip_id+" with quote id: "+updateQuoteResponse.data.quote_id);
            window.location = ("/viewquote/"+updateQuoteResponse.data.quote_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
  // 
  //   setfinalfiledetails([...finalfiledetails, temp])
  }catch(e){
    console.log(e)
  }
  
}

const sendquote=async(name)=>{
  //var resultlink={}
  const link="https://www.jetovacations.com/quote/"+quoteData._id
  console.log(link)
  // const options = {
  //   method: 'POST',
  //   url: 'https://fast-url-shortener1.p.rapidapi.com/shorten',
  //   headers: {
  //     'content-type': 'application/json',
  //     'X-RapidAPI-Key': 'cde1cb76b4msha89f211c8450471p184a4bjsnc8c9ae6f8fd1',
  //     'X-RapidAPI-Host': 'fast-url-shortener1.p.rapidapi.com'
  //   },
  //   data: {
  //     url: link,
  //   }
  // };
  
  try {
    // const response = await axios.request(options);
    // console.log(response.data);
    // const temp=result.split(":").slice(1,2)
    //   console.log(temp)
    //   const temp2=temp[0].replaceAll('"',"")
    var text2=""
    var min=Math.min(quoteData.day.length,4)
    for (let i=0;i<min;i++){
      text2=text2+"*Day "+(i+1)+":* "+quoteData.day[i].tour_name+"%0a"
    }
    var text=""
    if(name=="Send new format custom quote (quote details)"){
      text=`Please find your `+`${quoteData.primary_destination}`+` quote customized as per the requirements shared by you (click the link below)`+ `%0a%0a` + text2  + `%0a` + `*Link to complete Quote:* `+`${link}`
      //+`%0a%0a`+`In case you are unable to reach me, you can always contact Abhishek (9999025954), Hitesh (8595354230), Shubham (7042239956)`
    }else if(name=="Send new format sample quote (quote details)"){
      text=`Please find your sample quote (click the link below) for `+`${quoteData.primary_destination}`+`. We could not create a customized quote for you because we are unable to contact you and understand your specific requirements.`+ `%0a%0a` + text2  + `%0a` +`*Link to Quote:* `+`${link}`
    }else if(name=="Send new format custom quote"){
      text=`Please find your `+`${quoteData.primary_destination}`+` quote customized as per the requirements shared by you (click the link below)`+ `%0a%0a` + `*Link to complete Quote:* `+`${link}`
    }else{
      text=`Please find your sample quote (click the link below) for `+`${quoteData.primary_destination}`+`. We could not create a customized quote for you because we are unable to contact you and understand your specific requirements.`+ `%0a%0a` + `*Link to Quote:* `+`${link}`
    }
     
    console.log(text)
    var win = window.open(
      `https://wa.me/91${quoteData.trip_details.primary_mobile_number}?text=${text}`,
      "_blank"
    );
  } catch (error) {
    console.error(error);
  }
// try {
// 	const response = await fetch(url, options);
// 	const result = await response.text();
// 	console.log(result);
//   const temp=result.split(":").slice(1,2)
//   console.log(temp)
//   const temp2=temp[0].replaceAll('"',"")
//   var text=`Please find your quote customized as per the requirements shared by you`+ `%0a%0a` +`${temp2}`
// console.log(text)
// var win = window.open(
//   `https://wa.me/91${quoteData.trip_details.primary_mobile_number}?text=${text}`,
//   "_blank"
// );
// } catch (error) {
// 	console.error(error);
// }
  

  
}

const deleteimage=async(loc)=>{
  try{
    const temp=[...quoteData.filelocation]
    const temp2=temp.filter(data=> data.location !==loc)
    const finalquoteData={...quoteData, filelocation:temp2}
    console.log(finalquoteData)
    const updateQuoteResponse= await updatequoteData(finalquoteData._id,finalquoteData);
        
        if(updateQuoteResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Quote updated for trip with trip id "+updateQuoteResponse.data.trip_id+" with quote id: "+updateQuoteResponse.data.quote_id);
            window.location = ("/viewquote/"+updateQuoteResponse.data.quote_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }

  }catch(error){
    console.log(error)
  }
}

const handleClose2 = () => {
  setOpen2(false);
};

const getwa=async(quote)=>{
  try{
    const data3 = await fetchwadata();
   
    const walist2 = data3.data.filter(
      (wa) =>
        wa.wa_trip == true &&
        (wa.wa_custom == false || wa.wa_owner == quote.trip_details.trip_owner)
    );
  
    const walist3=walist2.sort((a, b) => {
      let fa = a.group_id,
          fb = b.group_id,
          fc=a.wa_id,
          fd=b.wa_id
  
      if (fa < fb) {
          return -1;
      }
      if (fa > fb) {
          return 1;
      }
      if(fa==fb){
        if(fc<fd){
          return -1
        }
        if(fc>fd){
          return 1
        }
      }
      return 0;
  });
  setwalist(walist3)
  }catch(error){
    console.log(error)
  }
}

const whatsapp = (name) => {
  if (quoteData.trip_details.primary_mobile_number) {
    if(name=="Send new format custom quote" || name=="Send new format sample quote" || name=="Send new format sample quote (quote details)" || name=="Send new format custom quote (quote details)"){
      sendquote(name)
    }else{
    var d = new Date().getHours();


    var extratext = "";
    if (d > 5 && d < 12) {
      extratext = "Good Morning !";
    } else if (d >= 12 && d < 17) {
      extratext = "Good Afternoon !";
    } else if (d >= 18 && d < 23) {
      extratext = "Good Evening !";
    }

    var body = walist.filter((wa) => wa.wa_name == name);
    var text2 = "";
    if (body[0].wa_id > 35 && body[0].wa_id < 40) {
      text2 = extratext + "%0a%0a" + body[0].wa_body;
    } 
    else {
      text2 = body[0].wa_body;
    }
    var text5 = text2.replace("<destination>", quoteData.trip_details.primary_destination);
    var text6 = text5.replace("<x>", quoteData.trip_details.duration);
    var text7 = text6.replace(
      "<date>",
      quoteData.trip_details.trip_start_date.split("T").slice(0, 1)
    );
    var text8 = text7.replace("<pax>", quoteData.trip_details.number_adults);
    var text9 = text8.replace("<owner>", quoteData.trip_details.trip_owner);
    var text4 = text9.replace("<name>", quoteData.trip_details.cust_name);
    var text3 = text4.split("||");
    
    
    var text = "";
    for (var i = 0; i < text3.length; i++) {
      if (i == 0) {
        text = text3[i];
      } else {
        text = text + "%0a" + text3[i];
      }
    }

    // if(body[0].wa_id==69){
    //   // text="We have not heard from you in a while and wanted to know if there is any problem where we could help. If you kindly let us know the issue, it will be helpful for both of us.%0a%0a1. *All good. Will contact you soon* %0ahandypolls.com/o/ngQWrk %0a%0a2. *Waiting for someone else to confirm* %0ahandypolls.com/o/nJvM7W %0a%0a3. *Waiting for some other event (e.g. leaves, arranging funds etc.)* %0ahandypolls.com/o/ePoRLZ %0a%0a4. *Still not sure about the plan. Exploring more options* %0ahandypolls.com/o/nxLomk %0a%0a5. *Plans are final but not sure about your company* %0ahandypolls.com/o/85Wd2v %0a%0a6. *Not interested anymore. Kindly cancel* %0ahandypolls.com/o/nZaWxa"
    //   text="poll%0ajetovacations.com"
    // }
  
    var win = window.open(
      `https://wa.me/91${quoteData.trip_details.primary_mobile_number}?text=${text}`,
      "_blank"
    );
  }
  } else {
    alert(
      "Chat mobile number not present. Please enter number and try again"
    );
  }
};
    //console.log(filedetails)
    // UploadImages.js

// import React, { useState } from 'react';
// import axios from 'axios';

// const UploadImages = () => {
//   const [images, setImages] = useState([]);

//   const handleImageChange = (e) => {
//     setImages([...images, ...e.target.files]);
//   };

//   const handleImageUpload = async () => {
//     const formData = new FormData();
//     images.forEach((image) => {
//       formData.append('images', image);
//     });

//     try {
//       await axios.post('http://localhost:3001/upload', formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       console.log('Images uploaded successfully');
//     } catch (error) {
//       console.error('Error uploading images:', error);
//     }
//   };

//   return (
//     <div>
//       <input type="file" accept="image/*" onChange={handleImageChange} multiple />
//       <button onClick={handleImageUpload}>Upload Images</button>
//     </div>
//   );
// };

// export default UploadImages;


  //console.log(tboflightdata);
  return (
    <div>
      <Dialog fullWidth maxWidth="lg" open={Open2} onClose={handleClose2}>
        <a
          href="https://docs.google.com/spreadsheets/d/1D7huwcWGlh0prUBXL4KVYlxd5wpo3IKvQvuq7F__mVg/edit#gid=0"
          rel="noopener noreferrer"
          target="_blank"
          variant="h6"
          align="center"
          className={classes.headertext}
        >
          {" "}
          Doc Link for detailed messages
        </a>
        <TableContainer>
          <Table>
           
            <TableBody>
              {walist?.map((wa) => {
                return (
                  <div>
                  <TableRow key={wa.wa_id} align="center">
                  <Typography
              variant="h5"
              align="center"
              className={classes.headertext}
            >
              {" "}
              {wa.group_name?wa.group_name:""}
            </Typography>   
                  </TableRow>
                    <TableRow key={wa.wa_id} align="center">
                      <TableCell
                        style={{ width: 420, height: 10 }}
                        align="center"
                      >
                        {wa.wa_name} - {wa.wa_category}{" "}
                      </TableCell>
                      <TableCell>
                        {/* {wa.wa_id > 35 && wa.wa_id < 40 ? ( */}
                          
                            <Button
                              onClick={() => whatsapp(wa.wa_name)}
                              variant="outlined"
                              color="primary"
                              className={classes.smallbutton2}
                            >
                              Send
                            </Button>
                            </TableCell>
                            {/* <TableCell>
                            <Button
                    onClick={handleSubmit2}
                    variant="contained"
                    color="primary"
                    className={classes.smallbutton2}
                  >
                    Save
                  </Button>
                  </TableCell> */}
                    </TableRow>
                    
                  </div>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Dialog>
 
    <div className={classes.div}>
      <h3> New PDF available for Bali, Thailand, Philippines, Singapore, Malaysia, Turkey, Dubai, Maldives, Vietnam, Sri Lanka, Andaman, Kashmir, Ladakh, Rajasthan, Azerbaijan, Kazakhstan,Goa, Kerala, Himachal, Sikkim</h3>
      <h3> New PDF does not support flight data in quote</h3>
      {cuser=="Debayan"?(<Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={downpdf}
      >
        Server PDF
      </Button>):("")}
     <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={openlink}
      >
        Website Link
      </Button>
    
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={()=>setOpen2(true)}
      >
        Whatsapp
      </Button>
      {/* <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={choosepdf}
      >
        Old PDF
      </Button>
      <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={savepdf4}
      >
        Old PDF - flight
      </Button> */}
      <br></br>
      <Button
        href={"/quotedataentry/" + quoteData.quote_id}
        variant="contained"
        color="secondary"
        className={classes.button}
      >
        Back to Quote
      </Button>
      <Button
        href={"/tripdataentry/" + quoteData.trip_id}
        variant="contained"
        color="secondary"
        className={classes.button}
      >
        Back to Trip
      </Button>
      <br></br>
      <h2 className={classes.redheadtext}>Always use link for sharing quotes instead of PDF</h2>
      <h3 className={classes.redheadtext}>Links have restaurant list, images of hotels, images of tours and multiple options for customer response. Trips with links as quotes have greater probability of converion</h3>
      <Table>
        <TableRow>
          <TableCell>
            <p>For quote without flights</p>
          </TableCell>
          <TableCell>
          {/* <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={newpdf1}
      >
        New PDF
      </Button> */}
       <Button
        variant="contained"
        color="primary"
        className={classes.button}
         onClick={openlink}
      >
        Website Link
      </Button>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <p>For quote with flight screenshots</p>
          </TableCell>
          <TableCell>
          {/* <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={newpdf3}
      >
        New PDF-flights(ss)
      </Button> */}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <p>For quote with API flights</p>
          </TableCell>
          <TableCell>
          {/* <Button
        variant="contained"
        color="primary"
        className={classes.button}
        onClick={newpdf4}
      >
        New PDF- new flights
      </Button> */}
          </TableCell>
        </TableRow>
      </Table>
      
     
     

      <div>
        <FormControl
          style={{
            minWidth: 480,
            marginTop: 16,
            marginRight: 32,
            marginLeft: 8,
          }}
        >
          <InputLabel id="Channel">Channel</InputLabel>
          <Select
            classname={classes.textField}
            labelId="Channel"
            onChange={(e) => (x = e.target.value)}
          >
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
          </Select>
        </FormControl>
        <br></br>
        <div>
          <label for="myfile">Choose image:</label>
          <input
            type="file"
            name="myfile"
            id="myfile"
            width="200px"
            height="50px"
            // onChange={(e)=>handleFileInput(e)}
          ></input>
        </div>
        <br></br>
        <div id="image1">
          <p className={classes.para}>
            <b>Flight Details: </b>
          </p>
          <img
            alt="Preview"
            id="imagePreview"
            width="600px"
            height="300px"
          ></img>
        </div>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 1</button>
        <br></br>
        <img
          alt="Preview2"
          id="imagePreview2"
          width="600px"
          height="300px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 2</button>
        <br></br>
        <img
          alt="Preview3"
          id="imagePreview3"
          width="600px"
          height="300px"
        ></img>
        <br></br>
        <button onClick={(e) => removeimage(e)}>Remove Image 3</button>
        
      </div>
     <Button
            variant="contained"
            color="primary"
            onClick={uploadfile}
            className={classes.button}
          >
         Upload & Save
          </Button>
      
          <div>
            {"filelocation" in quoteData && quoteData.filelocation.map(img=>{return(
              <div>
              <img src={img.location} with="200px" height="100px" alt="file"></img>
              <br></br>
              <Button  color="secondary" onClick={()=>deleteimage(img.location)}>Delete & Save</Button>
              </div>
            )})}
          </div>
      <div id="1header">
        {/* <p align="center">
          ------------------------------------------------JETO
          VACATIONS---------------------------------------------
        </p> */}
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Quote {quoteData.quote_id}:</b>
            <Typography display="inline" className={classes.texttypo}>
              {" "}
              {quoteData.quote_header}
            </Typography>
          </Typography>
        </p>

        <table>
          <tr>
            <td>
              <div class="col" className={classes.column}>
                <Typography className={classes.texttypo2}>
                  <b>Name: </b>
                  <Typography display="inline" className={classes.texttypo}>
                    {" "}
                    {quoteData.cust_name}
                  </Typography>
                </Typography>
              </div>
            </td>
            <td>
              <div class="col" className={classes.column}>
                <Typography className={classes.texttypo2}>
                  <b>Start Date: </b>
                  <Typography display="inline" className={classes.texttypo}>
                    {" "}
                    {quoteData.trip_start_date
                      ? formatDate2(quoteData.trip_start_date)
                      : ""} ({quoteData.duration}N / {quoteData.duration+1}D)
                  </Typography>
                </Typography>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="col" className={classes.column}>
                <Typography className={classes.texttypo2}>
                  <b>Destination: </b>
                  <Typography display="inline" className={classes.texttypo}>
                    {" "}
                    {quoteData.primary_destination}
                  </Typography>
                </Typography>
              </div>
            </td>
            <td>
              <div class="col" className={classes.column}>
                <Typography className={classes.texttypo2}>
                  <b>Pax: </b>
                  <Typography display="inline" className={classes.texttypo}>
                    {" "}
                    {quoteData.number_adults} adults + {quoteData.number_child}{" "}
                    children
                  </Typography>
                </Typography>
              </div>
            </td>
          </tr>
        </table>
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Trip Requirements: </b>
            <br></br>
            <Typography display="inline" className={classes.texttypo}>
              {" "}
              {quoteData.trip_requirements}
            </Typography>
          </Typography>
        </p>
        <br></br>
      </div>
      <div id="flight">
        {flightdata.length > 0 ? (
          <div>
            <p className={classes.para}>
              <Typography className={classes.texttypo2}>
                <b>Flight Details: </b>
              </Typography>
            </p>
            <div align="left">
              {flightdata.map((flight) => {
                return (
                  <div>
                    <div align="center">
                      <b>
                        <i>
                          <Typography className={classes.icon}>
                            {flight.timediff
                              ? ""
                              : flight.leg_id == 0
                              ? "Onward"
                              : flight.leg_id == 1
                              ? "Return"
                              : ""}{" "}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </Typography>
                        </i>
                      </b>
                    </div>
                    <table border="0" width="700" height="30">
                      <div
                        class="col"
                        className={classes.column5}
                        align="center"
                      >
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography className={classes.texttypo2}>
                                <FlightTakeoffIcon className={classes.icon} />
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    &nbsp;&nbsp;{flight.source_airport} &nbsp;
                                    {flight.source_airport_code
                                      ? "(" + flight.source_airport_code + ")"
                                      : ""}
                                    &nbsp;&nbsp;
                                  </b>{" "}
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8} align="center">
                              <Typography className={classes.texttypo2}>
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    -----
                                    <AccessTimeIcon className={classes.icon} />
                                    &nbsp;
                                    {flight.duration
                                      ? Math.floor(flight.duration / 60) +
                                        " hrs " +
                                        (flight.duration % 60) +
                                        " mins "
                                      : ""}
                                    -----
                                  </b>{" "}
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography className={classes.texttypo2}>
                                <FlightLandIcon className={classes.icon} />
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    &nbsp;&nbsp;{flight.destination_airport}{" "}
                                    &nbsp;
                                    {flight.destination_airport_code
                                      ? "(" +
                                        flight.destination_airport_code +
                                        ")"
                                      : ""}
                                  </b>
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td className={classes.texttypo5}>
                            <em>Leg:{flight.leg_id + 1}</em>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>
                                  {String(flight.source_time).substring(0, 5)}{" "}
                                </b>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}></div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>
                                  {String(flight.destination_time).substring(
                                    0,
                                    5
                                  )}
                                </b>
                              </Typography>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>{formatDate2(flight.source_date)} </b>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8} align="center">
                              -----
                              {flight.airline ? flight.airline : ""}
                              -----
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>{formatDate2(flight.destination_date)}</b>
                              </Typography>
                            </div>
                          </td>
                          <td className={classes.texttypo5}>
                            <em>Segment:{flight.segment_id + 1}</em>
                          </td>
                        </tr>
                      </div>
                    </table>
                    <br></br>
                    <Divider className={classes.divider2} variant="middle" />

                    <div align="center">
                      {flight.timediff && flight.timediff > 0
                        ? "Layover: " +
                          Math.round(flight.timediff / 60) +
                          "hrs " +
                          (flight.timediff % 60) +
                          "mins"
                        : ""}
                    </div>
                    <Divider className={classes.divider2} variant="middle" />
                    <br></br>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <p className={classes.para}>
            <Typography className={classes.texttypo2}>
              <b>Flight Details: </b>
              <Typography display="inline" className={classes.texttypo}>
                {" "}
                Flights not included
              </Typography>
            </Typography>
          </p>
        )}
      </div>
      <div id="flight2">
        {tboflightdata.length > 0 ? (
          <div>
            <p className={classes.para}>
              <Typography className={classes.texttypo2}>
                <b>Flight Details: </b>
              </Typography>
            </p>
            <div align="left">
              {tboflightdata.map((result) => {
                return (
                  <div>
                    <div align="center" className={classes.icon2}>
                      <b >
                        <i>
                          <Typography className={classes.icon} variant="h5">
                            {tboflightdata.length>1 && "ResultIndex" in result && result.ResultIndex.startsWith("OB")?"Onward":result.ResultIndex.startsWith("IB")?"Return":""}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </Typography>
                        </i>
                      </b>
                    </div>
                    {result.Segments.map(flight =>
                    <div align="center">
                    <div align="center" className={classes.icon2}>
                      <b >
                        <i>
                          <Typography className={classes.icon} variant="h5">
                            {result.Segments.length<3?tboflightdata.length==1 && "TripIndicator" in flight[0] && flight[0].TripIndicator==1?"Onward":flight[0].TripIndicator==2?"Return":"":"Multi-stop"}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </Typography>
                        </i>
                      </b>
                    </div>
                      {flight.map(segment=>
                        <table border="0" width="700" height="30">
                        
                      <div
                        class="col"
                        className={classes.column5}
                        align="center"
                      >
                      {"GroundTime" in segment && segment.GroundTime>0?(
                        <div>
                        <br></br>
                        <hr></hr>
                        <tr>
                      <td></td>
                      <td>
                    <div align="center"><b>
                    {"GroundTime" in segment && segment.GroundTime>0?("StopOver: "+Math.floor(segment.GroundTime/60)+ "hrs "+ segment.GroundTime%60 + "mins"):(flight[flight.indexOf(segment)-1]?"StopOver: "+Math.floor((new Date(segment.Origin.DepTime).getTime()-new Date(flight[flight.indexOf(segment)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.floor((new Date(segment.Origin.DepTime).getTime()-new Date(flight[flight.indexOf(segment)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}</b>
                    </div>
                    </td>
                    <td></td>
                        </tr>
                        <hr></hr>
                        <br></br>
                        </div>
                      ):("")}
                      
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography className={classes.texttypo2}>
                                <FlightTakeoffIcon className={classes.icon} />
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    &nbsp;&nbsp;{segment.Origin.Airport.AirportName} &nbsp;
                                     {"(" + segment.Origin.Airport.AirportCode + ")"}
                                     
                                    &nbsp;&nbsp;
                                  </b>{" "}
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8} align="center">
                              <Typography className={classes.texttypo2}>
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    -----
                                    <AccessTimeIcon className={classes.icon} />
                                    &nbsp;
                                    {segment.Duration && segment.Duration>0
                                      ? (Math.floor(segment.Duration / 60) +
                                        " hrs " +
                                        (segment.Duration % 60) +
                                        " mins ")
                                    
                               
                                                                       : (Math.floor((new Date(segment.Destination.ArrTime).getTime()-new Date(segment.Origin.DepTime).getTime())/(1000*60*60))+" hrs " +Math.floor(((new Date(segment.Destination.ArrTime).getTime()-new Date(segment.Origin.DepTime).getTime())/(1000*60))%60)+" mins")
                                      
                                      }
                                    -----
   
                                  </b>{" "}
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography className={classes.texttypo2}>
                                <FlightLandIcon className={classes.icon} />
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    &nbsp;&nbsp;{segment.Destination.Airport.AirportName}{" "}
                                    &nbsp;
                                    {"(" +
                                    segment.Destination.Airport.AirportCode +
                                        ")"
                                      }
                                  </b>
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          {/* <td className={classes.texttypo5}>
                            <em>Leg: {flight.indexOf(segment)+1}</em>
                          </td> */}
                        </tr>
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>
                                  {formatDate2(String(segment.Origin.DepTime).split("T").slice(0,1))}{" "}
                                </b>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              {"Baggage" in segment?segment.Baggage?"Check-in Baggage: "+segment.Baggage:"Check-in Baggage:0 kgs":""} 
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>
                                  {formatDate2(String(segment.Destination.ArrTime).split("T").slice(0,1))}
                                </b>
                              </Typography>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>{String(segment.Origin.DepTime).split("T").slice(1,2)[0].substring(0,5)} </b>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8} align="center">
                              -----
                              {segment.Airline.AirlineCode ? segment.Airline.AirlineName + " ("+segment.Airline.AirlineCode+")" : ""}
                              -----
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>{String(segment.Destination.ArrTime).split("T").slice(1,2)[0].substring(0,5)}</b>
                              </Typography>
                            </div>
                          </td>
                          {/* <td className={classes.texttypo5}>
                            <em>Seg: {result.Segments.indexOf(flight) + 1}</em>
                          </td> */}
                        </tr>
                        
                      </div>
                    </table>
                      )}
                      <br></br>
                      <hr className={classes.line}></hr>
                      
                     
                    </div>
                    )}
                    <br></br>
                    <Divider className={classes.divider2} variant="middle" />
                    
                    <Divider className={classes.divider2} variant="middle" />
                    <br></br>
                  </div>
                );
              })}
            </div>
            
            <Typography className={classes.texttypo2b}>{"baggage" in quoteData?("Extra Baggage: "+quoteData.baggage):""}</Typography>
           
          </div>
        ) : (
          <p className={classes.para}>
            <Typography className={classes.texttypo2}>
              <b>Flight Details: </b>
              <Typography display="inline" className={classes.texttypo}>
                {" "}
                Flights not included
              </Typography>
            </Typography>
          </p>
        )}
      </div>
      <div id="flight3">
        {"travclan_flight" in quoteData && quoteData.travclan_flight.length > 0 ? (
          <div>
            <p className={classes.para}>
              <Typography className={classes.texttypo2}>
                <b>Flight Details: </b>
              </Typography>
            </p>
            <div align="left">
              {quoteData.travclan_flight.map((result) => {
                return (
                  <div>
                    <div align="center" className={classes.icon2}>
                      <b >
                        <i>
                          <Typography className={classes.texttypo4} variant="h5">
                            {quoteData.travclan_flight.indexOf(result)+1==1 ?"Onward":"Return"}
                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          </Typography>
                        </i>
                      </b>
                    </div>
                    {result.sg.map(segment =>
                    <div align="center">
                        <table border="0" width="700" height="30">
                        
                      <div
                        class="col"
                        className={classes.column5}
                        align="center"
                      >
                    
                        <div>
                        <br></br>
                        <hr></hr>
                        <tr>
                      <td></td>
                      <td>
                    <div align="center"><b>
                    {result.sg.length>1 && "gT" in segment && segment.gT>0?("StopOver: "+Math.floor(segment.gT/60)+ "hrs "+ segment.gT%60 + "mins"):("")}</b>
                    </div>
                    </td>
                    <td></td>
                        </tr>
                        <hr></hr>
                        <br></br>
                        </div>
                    
                      
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography className={classes.texttypo2}>
                                <FlightTakeoffIcon className={classes.icon} />
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    &nbsp;&nbsp;{segment.or.aN} &nbsp;
                                     {"(" + segment.or.aC + ")"}
                                     
                                    &nbsp;&nbsp;
                                  </b>{" "}
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8} align="center">
                              <Typography className={classes.texttypo2}>
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    -----
                                    <AccessTimeIcon className={classes.icon} />
                                    &nbsp;
                                    {segment.dr && segment.dr>0
                                      ? (Math.floor(segment.dr / 60) +
                                        " hrs " +
                                        (segment.dr % 60) +
                                        " mins ")
                                    
                               
                                                                       : (Math.floor((new Date(segment.ds.aT).getTime()-new Date(segment.or.dT).getTime())/(1000*60*60))+" hrs " +Math.floor(((new Date(segment.ds.aT).getTime()-new Date(segment.or.dT).getTime())/(1000*60))%60)+" mins")
                                      
                                      }
                                    -----
   
                                  </b>{" "}
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography className={classes.texttypo2}>
                                <FlightLandIcon className={classes.icon} />
                                <Typography
                                  display="inline"
                                  className={classes.texttypo4}
                                >
                                  <b>
                                    &nbsp;&nbsp;{segment.ds.aN}{" "}
                                    &nbsp;
                                    {"(" +
                                    segment.ds.aC +
                                        ")"
                                      }
                                  </b>
                                </Typography>
                              </Typography>
                            </div>
                          </td>
                         
                        </tr>
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>
                                  {formatDate2(String(segment.or.dT).split("T").slice(0,1))}{" "}
                                </b>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              {"bg" in segment?segment.bg?"Check-in Baggage: "+segment.bg:"Check-in Baggage:0 kgs":""} 
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>
                                  {formatDate2(String(segment.ds.aT).split("T").slice(0,1))}
                                </b>
                              </Typography>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>{String(segment.or.dT).split("T").slice(1,2)[0].substring(0,5)} </b>
                              </Typography>
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8} align="center">
                              -----
                              {segment.al.alC ? segment.al.alN + " ("+segment.al.alC+")" : ""}
                              -----
                            </div>
                          </td>
                          <td>
                            <div className={classes.column8}>
                              <Typography
                                display="inline"
                                className={classes.texttypo4}
                              >
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                <b>{String(segment.ds.aT).split("T").slice(1,2)[0].substring(0,5)}</b>
                              </Typography>
                            </div>
                          </td>
                          {/* <td className={classes.texttypo5}>
                            <em>Seg: {result.Segments.indexOf(flight) + 1}</em>
                          </td> */}
                        </tr>
                        
                      </div>
                    </table>
                  
                      <br></br>
                      <hr className={classes.line}></hr>
                      
                     
                    </div>
                    )}
                    <br></br>
                    <Divider className={classes.divider2} variant="middle" />
                    
                    <Divider className={classes.divider2} variant="middle" />
                    <br></br>
                  </div>
                );
              })}
            </div>
            
            <Typography className={classes.texttypo2b}>{"baggage" in quoteData?("Extra Baggage: "+quoteData.baggage):""}</Typography>
           
          </div>
        ) : (
          <p className={classes.para}>
            <Typography className={classes.texttypo2}>
              <b>Flight Details: </b>
              <Typography display="inline" className={classes.texttypo}>
                {" "}
                Flights not included
              </Typography>
            </Typography>
          </p>
        )}
      </div>
      <div id="5day" align="center">
        <ThemeProvider theme={theme2}>
          {daydata.map((day) => {
            return (
              <div id={daydata.indexOf(day)}>
                <table border="0" width="700">
                  <tr>
                    <th className={classes.daypara} align="left" width="690">
                      <Typography className={classes.texttypo2} variant="h5">
                        {" "}
                        Day {daydata.indexOf(day) + 1}:
                      </Typography>
                      <br></br>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <DateRangeIcon className={classes.icon} />
                          <b>&nbsp;Date:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {formatDate2(day.date)}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <RoomIcon className={classes.icon} />
                          <b>&nbsp;City:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.city}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <ApartmentIcon className={classes.icon} />
                          <b>&nbsp;Hotel Name:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.hotel_name} ({day.hotel_category} star)
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <RestaurantIcon className={classes.icon} />
                          <b>&nbsp;Meal Plan:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.meal_plan}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                  </tr>
                </table>
                <br></br>
                <Divider className={classes.divider2} variant="middle" />
                <br></br>
                <table border="0" width="700">
                  <tr>
                    <p className={classes.tablepara2}>
                      <Typography className={classes.texttypo2}>
                        <BedroomParentIcon className={classes.icon} />
                        <b>&nbsp;Room Details:</b> <br></br>{" "}
                        <Typography
                          display="inline"
                          className={classes.texttypo}
                        >
                          {"number_rooms" in day?day.room_type+" X "+day.number_rooms:day.room_type}
                        </Typography>
                      </Typography>
                    </p>
                  </tr>
                  <tr>
                    <p className={classes.tablepara2}>
                      <Typography className={classes.texttypo2}>
                        <AttractionsIcon className={classes.icon} />
                        <b>&nbsp;Tour Name:</b> <br></br>{" "}
                        <Typography
                          display="inline"
                          className={classes.texttypo}
                        >
                          {day.tour_name}
                        </Typography>
                      </Typography>
                    </p>
                  </tr>
                  <tr>
                    <p className={classes.tablepara2}>
                      <Typography className={classes.texttypo2}>
                        <DirectionsCarIcon className={classes.icon} />
                        <b> &nbsp;Tour Description:</b> <br></br>{" "}
                        <Typography
                          display="inline"
                          className={classes.texttypo}
                        >
                          {day.tour_description}
                        </Typography>
                      </Typography>
                    </p>
                  </tr>
                </table>
              </div>
            );
          })}
        </ThemeProvider>
      </div>

      <div id="2details">
        
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>What to do next: </b>
          </Typography>
          
          <br></br>
          <b>1. Want to change plans?</b> No problem, we will change it until
          it's perfect! <br></br>
          <br></br>
          <b>2. Want to change hotels?</b>No problem, we will get you just the
          right one ! <br></br>
          <br></br>
          <b>3. Concerned about price?</b> No problem, we can customize. Just
          ask ! <br></br>
          <br></br>
          Whatever you want, just ask <b>{quoteData.trip_owner}</b> at{" "}
          <b>{eData?.contact}</b> In case you are unable to reach me, you can always contact Abhishek (9999025954), Hitesh (8595354230), Rohit (7683060575) ! <br></br>
        </p>
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>FAQs: </b>
          </Typography>
          
          <br></br>
          <b>1. Can this package be customized?</b> 
          <p>Yes, each and every aspect of this package can be customized as per your needs.</p> 
          <br></br>
          <b>2. What are the payment terms?</b>
          <p>You need to pay a small token amount for confirming your booking of your land part. Rest of the amount can be paid in installments. Complete amount needs to be paid 7 days prior to travel. Complete payment for flights and cruise needs to be paid at the time of booking. Complete payment of visa needs to made at the time of application.</p><br></br>
          <br></br>
          <b>3. How long are the rates valid?</b> 
          <p>Flight and hotel rates are dynamic. Activity and transport rates are fixed unless your travel is within the next 3 days</p><br></br>
          <br></br>
          <b>4. What documets do you need?</b> 
          <p>For International trips we need passports and PAN card. For domestic trips we need Adhaar or voter cards</p> <br></br>
          Whatever you want, just ask <b>{quoteData.trip_owner}</b> at{" "}
          <b>{eData?.contact}</b> ! <br></br>
        </p>
       </div>
       <div id="2bdetails">
       <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Customer Notes:</b>
          </Typography>
          <br></br>
        </p>
        {identifydest(quoteData.primary_destination)?
        <li className={classes.daypara}>Passport must be valid for 6 months post completion of international trip for all passengers</li>
        :""}
        <li className={classes.daypara}>Car will be on point-to-point basis and  not on disposal basis unless specified otherwise</li>
        {quoteData.cust_notes_arr?.map((cnotes) => {
          return (
            <div>
              <li className={classes.daypara}>{cnotes}</li>
            </div>
          );
        })}
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Inclusions: </b>
          </Typography>
          <br></br>
        </p>
        {quoteData.inclusions_arr?.map((incl) => {
          return (
            <div>
            
              <li className={classes.daypara}>{incl}</li>
            </div>
          );
        })}
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Exclusions: </b>
          </Typography>
          <br></br>
        </p>
        {quoteData.exclusions_arr?.map((excl) => {
          return (
            <div>
              <li className={classes.daypara}>{excl}</li>
            </div>
          );
        })}
      </div>
      <div id="3account">
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Price Details: </b>
          </Typography>
        </p>
        <div align="center">
          <div align="center">
            {quoteData.quote_discount && quoteData.quote_discount_type ? (
              <table border="1" width="700" id="withdiscount">
                <tr>
                  <th></th>
                  <th className={classes.texttypo3}>
                    <b>Airfare </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>Land Package </b>
                  </th>

                  <th className={classes.texttypo3}>
                    <b>Other Items </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>Taxes </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>TCS </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>Total</b>
                  </th>
                </tr>
                <tr>
                  <td>
                    <div align="center" className={classes.column7}>
                      <tr className={classes.texttypo3}>
                        {" "}
                        <b>Total</b>
                      </tr>
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.airfare}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?("coupon" in quoteData && quoteData.coupon.length>0 && new Date().getTime()<new Date(quoteData.coupon[quoteData.coupon.length-1].expiry).getTime()?quoteData.quote_price.landprice-quoteData.coupon[quoteData.coupon.length-1].amount:quoteData.quote_price.landprice):""}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.otheritems}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?Math.round(quoteData.quote_price.taxes):0}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?Math.round(quoteData.quote_price.tcs):0}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      <b>
                        <s>{quoteData.quote_price?.total}</s>
                      </b>
                    </div>
                  </td>
                </tr>
                <tr></tr>
                <tr>
                  <td>
                    <div align="center" className={classes.column7}>
                      <tr className={classes.texttypo3}>
                        {" "}
                        <b>Discount</b>
                      </tr>
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      <tr className={classes.texttypo3}> Promo Code:</tr>
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {"coupon" in quoteData && quoteData.coupon.length>0 && new Date().getTime()<new Date(quoteData.coupon[quoteData.coupon.length-1].expiry).getTime()?quoteData.coupon[quoteData.coupon.length-1].code:""}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      <tr className={classes.texttypo3}> Amount:</tr>
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {"coupon" in quoteData && quoteData.coupon.length>0 && new Date().getTime()<new Date(quoteData.coupon[quoteData.coupon.length-1].expiry).getTime()?quoteData.coupon[quoteData.coupon.length-1].amount:""}
                    </div>
                  </td>

                  <td>
                    <div align="center" className={classes.column7}>
                      <b>
                      {quoteData.quote_price?("coupon" in quoteData && quoteData.coupon.length>0 && new Date().getTime()<new Date(quoteData.coupon[quoteData.coupon.length-1].expiry).getTime()?quoteData.quote_price.total-quoteData.coupon[quoteData.coupon.length-1].amount:quoteData.quote_price.total):""}
                        
                      </b>
                    </div>
                  </td>
                </tr>
              </table>
            ) : (
              <table border="1" width="700" id="withoutdiscount">
                <tr>
                  <th></th>
                  <th className={classes.texttypo3}>
                    <b>Airfare </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>Land Package </b>
                  </th>

                  <th className={classes.texttypo3}>
                    <b>Other Items </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>Taxes </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>TCS </b>
                  </th>
                  <th className={classes.texttypo3}>
                    <b>Total</b>
                  </th>
                </tr>
                <tr>
                  <td>
                    <div align="center" className={classes.column7}>
                      <tr className={classes.texttypo3}>
                        {" "}
                        <b>Total</b>
                      </tr>
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.airfare}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.landprice}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.otheritems}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?Math.round(quoteData.quote_price.taxes):0}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.tcs}
                    </div>
                  </td>
                  <td>
                    <div align="center" className={classes.column7}>
                      <b>{quoteData.quote_price?.total}</b>
                    </div>
                  </td>
                </tr>
              </table>
            )}
            <br></br>
            <table border="1" width="700" id="3rdtable">
              <tr>
                <td>
                  <div class="col" className={classes.column2}>
                    <tr className={classes.texttypo3}>
                      <b>Per Adult: </b>
                      {quoteData.quote_price?.perperson}
                    </tr>
                  </div>
                </td>
                <td>
                  <div class="col" className={classes.column2}>
                    <tr className={classes.texttypo3}>
                      <b>Per Child with bed: </b>
                      {quoteData.quote_price?.percwb}
                    </tr>
                  </div>
                </td>
                <td>
                  <div class="col" className={classes.column2}>
                    <tr className={classes.texttypo3}>
                      <b>Per Child w/o bed: </b> {quoteData.quote_price?.percnb}
                    </tr>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <img src={accounts2} width="795" alt="account details"></img>
      </div>
      <div id="3caccount">
      <p className={classes.texttypo11}>EMI facility available</p>
      <img src={value}  alt="value"></img>
      </div>
      <div id="3baccount">
      
      <table className={classes.table}>
        <tr >
          <td >
          <Typography className={classes.tablerow}>
            <FlightTakeoffIcon className={classes.icon} />
            <b>&nbsp;Airfare:</b>{" "}
           
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?.airfare}
            </Typography>
          </td>
          </tr>
          <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <ApartmentIcon className={classes.icon} />
            <b>&nbsp;Land Package:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?(quoteData.quote_discount?quoteData.quote_price.landprice-quoteData.quote_discount:quoteData.quote_price.landprice):""}
            </Typography>
          </td>
        </tr>
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <AttractionsIcon className={classes.icon} />
            <b>&nbsp;Other Items:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?.otheritems}
            </Typography>
          </td>
        </tr>
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <MonetizationOnIcon className={classes.icon} />
            <b>&nbsp;Taxes:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?Math.round(quoteData.quote_price.taxes):0}
            </Typography>
          </td>
        </tr>
        <tr className={classes.tablerow}>
        <td>
        <Divider className={classes.divider2} />
        <Divider className={classes.divider2} />
        <Divider className={classes.divider2} />
        <Divider className={classes.divider2} />
        </td>
        <td>
        <Divider className={classes.divider2}  />
        <Divider className={classes.divider2} />
        <Divider className={classes.divider2} />
        <Divider className={classes.divider2} />
        </td>
       
        </tr>
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <CurrencyRupeeIcon className={classes.icon} />
            <b>&nbsp;Total:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?(quoteData.quote_discount?(quoteData.quote_price.total-quoteData.quote_discount):quoteData.quote_price.total):""}
            </Typography>
          </td>
        </tr>
        {/* {destselect?(
          <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <CurrencyExchangeIcon className={classes.icon} />
            <b>&nbsp;TCS:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?.tcs}
            </Typography>
          </td>
        </tr>
        ):("")}
        {destselect?(
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <FunctionsIcon className={classes.icon} />
            <b>&nbsp;With TCS:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{quoteData.quote_price?.tcs+quoteData.quote_price?.total}
            </Typography>
          </td>
        </tr>
        ):("")} */}
        <tr className={classes.tablerow}>
        <td>
        <Divider className={classes.divider2} />
        <Divider className={classes.divider2} />
       
        </td>
        <td>
        <Divider className={classes.divider2}  />
        <Divider className={classes.divider2} />
        
        </td>
       
        </tr>
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <CurrencyRupeeIcon className={classes.icon} />
            <b>&nbsp;Per Adult:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp;{Math.round(quoteData.quote_price?.perperson?quoteData.quote_price.perperson:0)} 
            </Typography>
          </td>
        </tr>
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
            <CurrencyRupeeIcon className={classes.icon} />
            <b>&nbsp;Per CWB | CNB:</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  &nbsp;&nbsp; {Math.round(quoteData.quote_price?.percwb?quoteData.quote_price.percwb:0)} | {Math.round(quoteData.quote_price?.percnb?quoteData.quote_price.percnb:0)}
            </Typography>
          </td>
        </tr> 
        {quoteData.quote_discount && quoteData.quote_discount_type ? (
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
          <b>&nbsp;Amount (Promo Code):</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
                display="inline"
                className={classes.texttypo}
                >
                  {quoteData.quote_discount}({quoteData.quote_discount_type})
            </Typography>
          </td>
        </tr>
        ):("")}
        {quoteData.quote_discount && quoteData.quote_discount_type ? (
        <tr className={classes.tablerow}>
          <td >
          <Typography className={classes.tablerow}>
          <b>&nbsp;Total (Post Discount):</b>{" "}
            
          </Typography>
          </td>
          <td align="center">
          <Typography
               display="inline"
                className={classes.texttypo}
                >
                  {quoteData.quote_price?.total -
                          quoteData.quote_discount}
            </Typography>
          </td>
        </tr>
        ):("")}

          </table>
          <br></br>
        {destselect?(<div>
          <Typography><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5% TCS Additional (if PAN is provided). TCS Value: Rs. {quoteData.quote_price?.tcs}. </b></Typography>
          <Typography><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;20% TCS Additional (if PAN is not provided or remittance in this financial year crossed 10 lacs). TCS Value: Rs. {quoteData.quote_price?.tcs*4}. </b></Typography>
        <Typography><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Total payable including TCS: Rs.{quoteData.quote_price?(quoteData.quote_discount?(quoteData.quote_price.tcs+quoteData.quote_price.total-quoteData.quote_discount):(quoteData.quote_price.tcs+quoteData.quote_price.total)):""}</b></Typography>
        </div>):("")}
          <br></br>
          <br></br>
      <img src={accounts3} width="795" alt="account details"></img>
      </div>
      <div id="option2" align="center">
        {quoteData?.option2 ? (
          <div>
            <div>
              <h2 className={classes.texttypo2}>Option 2</h2>
              <Divider className={classes.divider2} variant="middle" />
              <h4>
                Only the hotel option has been changed. Everything else about
                the itinerary remains the same
              </h4>

              {daydata.map((day) => {
                return (
                  <div className={classes.daypara4}>
                  <table border="0" width="700">
                  <tr>
                    <th className={classes.daypara} align="left" width="690">
                      <Typography className={classes.texttypo2} variant="h5">
                        {" "}
                        Day {daydata.indexOf(day) + 1}:
                      </Typography>
                      <br></br>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <DateRangeIcon className={classes.icon} />
                          <b>&nbsp;Date:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {formatDate2(day.date)} ({day.city})
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <BedroomParentIcon className={classes.icon} />
                          <b>&nbsp;Room Details:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.room_type2}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <ApartmentIcon className={classes.icon} />
                          <b>&nbsp;Hotel Name:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.hotel_name2} ({day.hotel_category2} star)
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <RestaurantIcon className={classes.icon} />
                          <b>&nbsp;Meal Plan:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.meal_plan2}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                  </tr>
                </table>
                  </div>
                );
              })}
            </div>

            <div id="3account2">
              <p className={classes.para} align="left">
                <Typography className={classes.texttypo2}>
                  <b>Price Details: </b>
                </Typography>
              </p>
              <div align="center">
                <div align="center">
                  {quoteData.quote_discount && quoteData.quote_discount_type ? (
                    <table border="1" width="700">
                      <tr>
                        <th></th>
                        <th className={classes.texttypo3}>
                          <b>Airfare </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Land Package </b>
                        </th>

                        <th className={classes.texttypo3}>
                          <b>Other Items </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Taxes </b>
                        </th>
                        <th className={classes.texttypo3}>
                    <b>TCS </b>
                  </th>
                        <th className={classes.texttypo3}>
                          <b>Total</b>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}>
                              {" "}
                              <b>Total</b>
                            </tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.airfare}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.landprice2-quoteData.quote_discount}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.otheritems}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?Math.round(quoteData.quote_price.taxes2):0}
                          </div>
                        </td>
                        <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.tcs2}
                    </div>
                  </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <b>
                              <s>
                                {quoteData.quote_price?.total +
                                  quoteData.quote_price?.landprice2 -
                                  quoteData.quote_price?.landprice +
                                  quoteData.quote_price?.taxes2 -
                                  quoteData.quote_price?.taxes
                                  }
                              </s>
                            </b>
                          </div>
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}>
                              {" "}
                              <b>Discount</b>
                            </tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}> Promo Code:</tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_discount_type}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}> Amount:</tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_discount}
                          </div>
                        </td>

                        <td>
                          <div align="center" className={classes.column7}>
                            <b>
                              {Math.round(
                                quoteData.quote_price?.total +
                                  quoteData.quote_price?.landprice2 -
                                  quoteData.quote_price?.landprice -
                                  quoteData.quote_discount +
                                  quoteData.quote_price?.taxes2 -
                                  quoteData.quote_price?.taxes
                              )}
                            </b>
                          </div>
                        </td>
                      </tr>
                    </table>
                  ) : (
                    <table border="1" width="700">
                      <tr>
                        <th></th>
                        <th className={classes.texttypo3}>
                          <b>Airfare </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Land Package </b>
                        </th>

                        <th className={classes.texttypo3}>
                          <b>Other Items </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Taxes </b>
                        </th>
                        <th className={classes.texttypo3}>
                    <b>TCS </b>
                  </th>
                        <th className={classes.texttypo3}>
                          <b>Total</b>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}>
                              {" "}
                              <b>Total</b>
                            </tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.airfare}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.landprice2}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.otheritems}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.taxes2}
                          </div>
                        </td>
                        <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.tcs}
                    </div>
                  </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <b>
                              {Math.round(
                                quoteData.quote_price?.total +
                                  quoteData.quote_price?.landprice2 -
                                  quoteData.quote_price?.landprice +
                                  quoteData.quote_price?.taxes2 -
                                  quoteData.quote_price?.taxes
                              )}
                            </b>
                          </div>
                        </td>
                      </tr>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div id="option3" align="center">
        {quoteData?.option3 ? (
          <div>
            <div>
              <h2 className={classes.texttypo2}>Option 3</h2>
              <Divider className={classes.divider2} variant="middle" />
              <h4>
                Only the hotel option has been changed. Everything else about
                the itinerary remains the same
              </h4>
              <div align="center">
                {daydata.map((day) => {
                  return (
                    <div id={daydata.indexOf(day)} className={classes.daypara4}>
                    <table border="0" width="700">
                  <tr>
                    <th className={classes.daypara} align="left" width="690">
                      <Typography className={classes.texttypo2} variant="h5">
                        {" "}
                        Day {daydata.indexOf(day) + 1}:
                      </Typography>
                      <br></br>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <DateRangeIcon className={classes.icon} />
                          <b>&nbsp;Date:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {formatDate2(day.date)} ({day.city})
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <BedroomParentIcon className={classes.icon} />
                          <b>&nbsp;Room Details:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.room_type3}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <ApartmentIcon className={classes.icon} />
                          <b>&nbsp;Hotel Name:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.hotel_name3} ({day.hotel_category3} star)
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                    <td>
                      <div className={classes.column6}>
                        <Typography className={classes.texttypo2}>
                          <RestaurantIcon className={classes.icon} />
                          <b>&nbsp;Meal Plan:</b>{" "}
                          <Typography
                            display="inline"
                            className={classes.texttypo}
                          >
                            {day.meal_plan3}
                          </Typography>
                        </Typography>
                      </div>
                    </td>
                  </tr>
                </table>
                    </div>
                  );
                })}
              </div>
            </div>

            <div id="3account3">
              <p className={classes.para} align="left">
                <Typography className={classes.texttypo2}>
                  <b>Price Details: </b>
                </Typography>
              </p>
              <div align="center">
                <div align="center">
                  {quoteData.quote_discount && quoteData.quote_discount_type ? (
                    <table border="1" width="700">
                      <tr>
                        <th></th>
                        <th className={classes.texttypo3}>
                          <b>Airfare </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Land Package </b>
                        </th>

                        <th className={classes.texttypo3}>
                          <b>Other Items </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Taxes </b>
                        </th>
                        <th className={classes.texttypo3}>
                    <b>TCS </b>
                  </th>
                        <th className={classes.texttypo3}>
                          <b>Total</b>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}>
                              {" "}
                              <b>Total</b>
                            </tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.airfare}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.landprice3-quoteData.quote_discount}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.otheritems}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.taxes3}
                          </div>
                        </td>
                        <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.tcs3}
                    </div>
                  </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <b>
                              <s>
                                {Math.round(
                                  quoteData.quote_price?.total +
                                    quoteData.quote_price?.landprice3 -
                                    quoteData.quote_price?.landpricequoteData
                                      .quote_price?.taxes3 -
                                    quoteData.quote_price?.taxes3
                                )}
                              </s>
                            </b>
                          </div>
                        </td>
                      </tr>
                      <tr></tr>
                      <tr>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}>
                              {" "}
                              <b>Discount</b>
                            </tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}> Promo Code:</tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_discount_type}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}> Amount:</tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_discount}
                          </div>
                        </td>

                        <td>
                          <div align="center" className={classes.column7}>
                            <b>
                              {Math.round(
                                quoteData.quote_price?.total +
                                  quoteData.quote_price?.landprice3 -
                                  quoteData.quote_price?.landprice -
                                  quoteData.quote_discount +
                                  quoteData.quote_price?.taxes3 -
                                  quoteData.quote_price?.taxes
                              )}
                            </b>
                          </div>
                        </td>
                      </tr>
                    </table>
                  ) : (
                    <table border="1" width="700">
                      <tr>
                        <th></th>
                        <th className={classes.texttypo3}>
                          <b>Airfare </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Land Package </b>
                        </th>

                        <th className={classes.texttypo3}>
                          <b>Other Items </b>
                        </th>
                        <th className={classes.texttypo3}>
                          <b>Taxes </b>
                        </th>
                        <th className={classes.texttypo3}>
                    <b>TCS </b>
                  </th>
                        <th className={classes.texttypo3}>
                          <b>Total</b>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <div align="center" className={classes.column7}>
                            <tr className={classes.texttypo3}>
                              {" "}
                              <b>Total</b>
                            </tr>
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.airfare}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.landprice3}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.otheritems}
                          </div>
                        </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            {quoteData.quote_price?.taxes3}
                          </div>
                        </td>
                        <td>
                    <div align="center" className={classes.column7}>
                      {quoteData.quote_price?.tcs}
                    </div>
                  </td>
                        <td>
                          <div align="center" className={classes.column7}>
                            <b>
                              {quoteData.quote_price?.total +
                                quoteData.quote_price?.landprice3 -
                                quoteData.quote_price?.landprice +
                                quoteData.quote_price?.taxes3 -
                                quoteData.quote_price?.taxes}
                            </b>
                          </div>
                        </td>
                      </tr>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>

      <div id="imgfooter">
        <img src={footer} width="795" alt="quote footer"></img>
      </div>
      <div id="imgfooter2">
        <img src={footer2} width="795" alt="quote footer2"></img>
      </div>
      <div id="endnotes">
        <p className={classes.para} align="left">
          <Typography className={classes.texttypo2}>
            <b>Cancellation Policy: </b>
          </Typography>

          <br></br>
        </p>
        <div>
              <li className={classes.daypara2}>
                Cancellation fee of Rs. 2,999 per person will be levied for all
                cancellations
              </li>
        {quoteData.cancellation_policy_arr?.map((cp) => {
          return (
            
              <li className={classes.daypara2}>{cp}</li>
            
          );
        })}
      </div>
        <p className={classes.para}>
          <Typography className={classes.texttypo2}>
            <b>Terms and Conditions: </b>
          </Typography>

          <br></br>
        </p>
        
        {quoteData.tnc_arr?.map((tnc) => {
          return (
            <div>
              <li className={classes.daypara2}>{tnc}</li>
            </div>
          );
        })}
        <li className={classes.daypara2}>
            {" "}
            Cost of deviation and cost of extension of the validity on your
            ticket is not included
          </li>
        <li className={classes.daypara2}>
          The itinerary is fixed and cannot be modified. Transportation shall be
          provided as per the itinerary and will not be at disposal.For any paid
          activity which is non-operational due to any unforeseen reason, we
          will try to arrange an alternate activity of similar cost and
          duartion. If no such activity can be provided we will process refund
          (as per cost to JVPL) & same should reach the guest within 30 days of
          processing the refund.
        </li>
        
        <h4 align="center"> ---------- See Below ----------</h4>
      </div>
      <div id="tnc">
        <div>
        <li className={classes.daypara2}>
            It is guest's responsibility to ensure that passport remains valid for 6 months post completion of an international trip. Jeto Vacations will not be held liable for any additional cost or charges that guest may need to bear for expiry of passports
          </li>
        <li className={classes.daypara2}>
          Also, for any activity which is complimentary and not charged to JVPL
          & guest, no refund will be processed
        </li>
        <li className={classes.daypara2}>
           Final tax invoice will be generated post payment of dues not before payment
        </li>
        <li className={classes.daypara2}>
          For land transfers, sapce is provided for 1 bag (15-25kg) per adult. If you are carrying more luggage then extra charges will be applicable as per vehicle rent
        </li>
        <li className={classes.daypara2}>
          Standard check-in time at the hotel varies on destination. An early
          check-in or a late check-out is solely based on the discretion of the
          hotel. Jeto vacations (JVPL) can place a request on your behalf but
          cannot guarantee that such requests would be honored. JVPL will not be
          liable if hotel denies such requests during traveler's stay at the
          hotel (even if hotel confirms before travel){" "}
        
        </li>
        <li className={classes.daypara2}>
          JVPL cannot be liable for issues arising out of rules followed by
          local operators and unions for e.g. AC will not be functional anywhere
          in cool or hilly areas, room heaters are charged extra, certain
          sightseeing areas are only serviced by local taxi unions, houseboat
          does not run after evening etc.{" "}
        </li>
          
          <li className={classes.daypara2}>
            If your flights involve a combination of different airlines, you may
            have to collect your luggage on arrival at the connecting hub and
            register it again while checking in for the onward journey to your
            destination.{" "}
          </li>
          <li className={classes.daypara2}>
            Airline seats and hotel rooms are subject to availability at the
            time of booking. Booking rates are subject to change without prior
            notice.{" "}
          </li>
          <li className={classes.daypara2}>
            JVPL cannot be held liable for mechanical failure of vehicle.
            However, JVPL will arrange alternate means of transport in case of
            major disruptions
          </li>
          <li className={classes.daypara2}>
            Pricing of the booking is based on the age of the passengers. Please
            make sure you mention the correct age of passengers at the time of
            booking. Age must be calculated based on day or travel and not on
            day of booking. Passengers furnishing incorrect age details may
            incur penalty at the time of travelling.{" "}
          </li>
          
          <li className={classes.daypara2}>
            In case your package needs to be cancelled due to any natural
            calamity, act of God, political/social events, war, weather
            conditions etc. JVPL shall strive to give you the maximum possible
            refund subject to the agreement made with our trade
            partners/vendors. JVPL can neither guarnatee full refund nor
            communicate exact amount before finalizing discussions with our
            partners/vendor
          </li>
          <li className={classes.daypara2}>
            {" "}
            JVPL reserves the right to modify the itinerary at any point, due to
            reasons including but not limited to: Force Majeure events, strikes,
            fairs, festivals, weather conditions, traffic problems, overbooking
            of hotels / flights, cancellation / re- routing of flights, closure
            of /entry restrictions at a place of visit, etc. While we will do
            our best to make suitable alternate arrangements, we would not be
            held liable for any refunds/compensation claims arising out of this.
          </li>
          
          <h4 align="center"> ---------- See Below ----------</h4>
        </div>
      </div>
      <div id="tnc2">
        <div>
        <li className={classes.daypara2}>
            In case of unavailability in the listed hotels, arrangement for an
            alternate accommodation will be made in a hotel of similar standard
          </li>
        <li className={classes.daypara2}>
            Entrance fee, parking and guide charges are not included in the
            packages unless explicitly mentioned
          </li>
        <li className={classes.daypara2}>
            Certain hotels may ask for a security deposit during check-in, which
            is refundable at check-out subject to the hotel's policy.{" "}
          </li>
          <li className={classes.daypara2}>
            The booking price does not include: Expenses of personal nature,
            such as airline seat selection fee, laundry, telephone calls, room
            service, alcoholic beverages, mini bar charges, tips, portage,
            camera fees etc.{" "}
          </li>
          <li className={classes.daypara2}>
            Any other items not mentioned under Inclusions are not included in
            the cost of the booking
          </li>
          <li className={classes.daypara2}>
            The package price doesn't include special dinner or mandatory
            charges at time levied by the hotels especially during New Year and
            Christmas or any special occasions. JVPL shall try to communicate
            the same while booking the package. However we may not have this
            information readily available all the time.
          </li>
          <li className={classes.daypara2}>
            {" "}
            JVPL will not be liable for any charges related to disruption/postponement/cancellation of trips due to delay of approval of visa or rejection of visa by the cosulate/embassy of any foreign country
          </li>
          <li className={classes.daypara2}>
            {" "}
            Any additional charges charged by end operators like airlines or
            hotels (e.g. check-in baggage charge, seat selection fee, extra
            items during meals etc.) will not be paid by JVPL unless explicitly
            mentioned in inclusions
          </li>
          <li className={classes.daypara2}>
            All holiday services including
            ferry/bus/train/sightseeing/event/theme parks/activities tickets are
            of base category seats (unless mentioned otherwise) and these are
            booked as per availability of seats. Hence, the timing or eaxt seat numbers cannot be
            confirmed at the time of booking the holiday package
          </li>
          <li className={classes.daypara2}>
            Moreover, the seats on any kind of transport are booked as per
            availability and basis the group size. Hence, we cannot assure the
            availability of adjoining seats.
          </li>
          <li className={classes.daypara2}>
            Hotel/Activity amenities and services provided by the operator and
            are based on the sole discretion. JVPL cannot be held liable if any
            operator (hotel/activity) denies such services or if the quality of
            such services are not upto client's expectations
          </li>
          <li className={classes.daypara2}>
            JVPL cannot be held liable if the operator goes bankrupt and are unable to provide services
          </li>
          <li className={classes.daypara2}>
            JVPL cannot be held liable for any financial losses including medical expenses, loss of valuables etc. that may occur due to unforeseen circumstances (e.g. accidents, thefts etc.)
          </li>
          <li className={classes.daypara2}>
            The activity/transport schedules is based on transport/activity
            operators and is administered by the government on most cases. We
            cannot be held liable if any disruptions happen due to sudden change
            of government rules (both local and central)
          </li>
          <li className={classes.daypara2}>
            Jeto Vacations reserves the right to cancel a booking without any
            refund if client/traveler does not follow the accepted payment terms
            or are late in paying the installments. JVPL will inform the client
            before taking any such step
          </li>
          <li className={classes.daypara2}>
            JVPL does not allow on ground payment option. All payments need to
            be completed before the start of trip
          </li>
          
          <li className={classes.daypara2}>
            Disputes, if any, shall be subject to the exclusive jurisdiction of
            the courts in New Delhi.{" "}
          </li>
        </div>
      </div>
      <div id="imgheader">
        <img
          onClick={() => console.log("abc")}
          src={header2}
          //src={bali1}
          width="795"
          alt="quote header"
        ></img>
      </div>
      <div id="accountsnew">
        <img
          onClick={() => console.log("abc")}
          src={accounts2}
          //src={bali1}
          width="795"
          alt="accounts new"
        ></img>
      </div>
      {quoteData.primary_destination == "Indonesia" ? (
        <div id="indonesia2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={bali2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Indonesia" ? (
        <div id="indonesia1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={bali1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Indonesia" ? (
        <div id="indonesia3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={bali3}
            width="795"
            alt="quote footer"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Indonesia" ? (
        <div id="indonesia4" width="700">
        <div align="center">
        <Typography className={classes.texttypo10}><KeyboardDoubleArrowLeftIcon className={classes.icon} />Other Options<KeyboardDoubleArrowRightIcon className={classes.icon} /> </Typography>
        <hr></hr>
        </div>
          <Table >
            <TableHead className={classes.daypara} align="center" width="590">
            <TableRow>
              <StyledTableCell width="80" align="center"><Typography className={classes.texttypo8}>Name</Typography></StyledTableCell>
              {/* <TableCell width="40"><Typography className={classes.texttypo8}>Duration</Typography></TableCell> */}
              <StyledTableCell width="160" align="center"><Typography className={classes.texttypo8}>Pros</Typography></StyledTableCell>
              <StyledTableCell width="160" align="center"><Typography className={classes.texttypo8}>Cons</Typography></StyledTableCell>
              <StyledTableCell width="80" align="center"><Typography className={classes.texttypo8}>Cost *</Typography></StyledTableCell>
              </TableRow>
            </TableHead>
            <StyledTableRow>
              <TableCell align="center"><Typography className={classes.texttypo6}>Recommended Package</Typography>
              <Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography>
              </TableCell>
              {/* <TableCell align="center"><Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography></TableCell> */}
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Customized as per your requirements</Typography>
              
              </TableCell>
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. None</Typography>
              
              </TableCell>
              <TableCell align="center"><Typography className={classes.texttypo6}>{Math.round((quoteData.quote_price.total-quoteData.quote_price.airfare)/((quoteData.number_adults+quoteData.number_child)*1000))}k</Typography></TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell align="center"><Typography className={classes.texttypo6}>Budget</Typography>
              <Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography>
              </TableCell>
              {/* <TableCell align="center"><Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography></TableCell> */}
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Affordable</Typography>
              <Typography className={classes.texttypo9}>2. Covers the must see spots in Bali</Typography>
              <Typography className={classes.texttypo9}>3. Can be covered in short duration</Typography>
              </TableCell>
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. No private pool villa</Typography>
              <Typography className={classes.texttypo9}>2. Limited sightseeing & activities</Typography>
              </TableCell>
              <TableCell align="center"><Typography className={classes.texttypo6}>{3+3*quoteData.duration}-{8+3*quoteData.duration}k</Typography></TableCell>
            </StyledTableRow>
            <StyledTableRow>
              <TableCell align="center"><Typography className={classes.texttypo9}>Premium</Typography>
              <Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography>
              </TableCell>
              {/* <TableCell align="center"><Typography className={classes.texttypo9}>{quoteData.duration}N/{quoteData.duration+1}D</Typography></TableCell> */}
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Covers all must visit spots and must do activities</Typography>
              <Typography className={classes.texttypo9}>2. Premium experience and hospitality</Typography>
              </TableCell>
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Costlier than average package</Typography>
              <Typography className={classes.texttypo9}>2. Cannot be completed in short duration</Typography>
              </TableCell>
              <TableCell align="center"><Typography className={classes.texttypo6}>{30+3*quoteData.duration}-{35+3*quoteData.duration}k</Typography></TableCell>
            </StyledTableRow>
            </Table>
            <br></br>
            <Typography className={classes.texttypo7}>Similar Destinations</Typography>
            <br></br>
            <Table border={0} width="700">
            <TableHead className={classes.daypara} align="center" width="690">
            <StyledTableCell width="80" align="center"><Typography className={classes.texttypo8}>Name</Typography></StyledTableCell>
              {/* <th width="65"><Typography className={classes.texttypo8}>Duration</Typography></th> */}
              <StyledTableCell width="160" align="center"><Typography className={classes.texttypo8}>Pros</Typography></StyledTableCell>
              <StyledTableCell width="160" align="center"><Typography className={classes.texttypo8}>Cons</Typography></StyledTableCell>
              <StyledTableCell width="80" align="center"><Typography className={classes.texttypo8}>Avg. Cost*</Typography></StyledTableCell>
            </TableHead>
            <StyledTableRow width="690">
              <TableCell align="center" ><Typography className={classes.texttypo6}>Maldives</Typography>
              <Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography>
              </TableCell>
              {/* <td align="center" ><Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography></td> */}
              <TableCell align="left" >
              <Typography className={classes.texttypo9}>1. One of top beach destinations in the world</Typography>
              <Typography className={classes.texttypo9}>2. Luxury hospitality</Typography>
              <Typography className={classes.texttypo9}>3. Option to stay at water villas</Typography>
              </TableCell>
              <TableCell align="left" >
              <Typography className={classes.texttypo9}>1. Costlier than Bali</Typography>
              <Typography className={classes.texttypo9}>2. No sightseeing spots and too few activities</Typography>
              <Typography className={classes.texttypo9}>3. No variety in landscape. Only beaches</Typography>
              </TableCell>
              <TableCell align="center" ><Typography className={classes.texttypo6}>{15+15*quoteData.duration}-{30+15*quoteData.duration}k</Typography></TableCell>
            </StyledTableRow>
            <StyledTableRow  width="690">
              <TableCell align="center" ><Typography className={classes.texttypo6}>Thailand</Typography>
              <Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography>
              </TableCell>
              {/* <TableCell align="center" ><Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography></TableCell> */}
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Affordable than Bali</Typography>
              <Typography className={classes.texttypo9}>2. Shorter flight duration</Typography>
              <Typography className={classes.texttypo9}>3. Wide variety in activities/sightseeing</Typography>
              
              </TableCell>
              <TableCell align="left">
              
              <Typography className={classes.texttypo9}>1. Needs longer duration to cover all the places</Typography>
              <Typography className={classes.texttypo9}>2. No private pool villa</Typography>
              
              </TableCell>
              <TableCell align="center" ><Typography className={classes.texttypo6}>{5+3*quoteData.duration}-{10+3*quoteData.duration}k</Typography></TableCell>
            </StyledTableRow>
            <StyledTableRow align="center" width="690">
              <TableCell align="center" ><Typography className={classes.texttypo6}>Andaman</Typography>
              <Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography>
              </TableCell>
              {/* <TableCell align="center" ><Typography className={classes.texttypo6}>{quoteData.duration}N/{quoteData.duration+1}D</Typography></TableCell> */}
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Affordable than Bali</Typography>
              <Typography className={classes.texttypo9}>2. Shorter flight duration</Typography>
              <Typography className={classes.texttypo9}>3. No visa/passport required</Typography>
              
              </TableCell>
              <TableCell align="left">
              <Typography className={classes.texttypo9}>1. Low variety in activities/sightseeing</Typography>
              <Typography className={classes.texttypo9}>2. No variety in landscape. Only beaches</Typography>
              <Typography className={classes.texttypo9}>3. No private pool villa</Typography>
              
              </TableCell>
              <TableCell align="center" ><Typography className={classes.texttypo6}>{0+3*quoteData.duration}-{5+3*quoteData.duration}k</Typography></TableCell>
            </StyledTableRow>
          </Table>
          <br></br>
          <Typography className={classes.texttypo4}> * Cost mentioned is per person excluding flights, visa and taxes</Typography>
          <br></br>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Singapore" ? (
        <div id="singapore1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={singapore1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Singapore" ? (
        <div id="singapore2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={singapore2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Singapore" ? (
        <div id="singapore3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={singapore3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Thailand" ? (
        <div id="thailand1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={thailand1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
       {quoteData.primary_destination == "Philippines" ? (
        <div id="philippines1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={philippines1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Thailand" ? (
        <div id="thailand2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={thailand2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
       {quoteData.primary_destination == "Philippines" ? (
        <div id="philippines2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={philippines2}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Thailand" ? (
        <div id="thailand3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={thailand3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
       {quoteData.primary_destination == "Philippines" ? (
        <div id="philippines3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={philippines3}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Dubai" ? (
        <div id="dubai1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={dubai1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      
      {quoteData.primary_destination == "Dubai" ? (
        <div id="dubai2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={dubai2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Dubai" ? (
        <div id="dubai3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={dubai3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Turkey" ? (
        <div id="turkey1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={turkey1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Turkey" ? (
        <div id="turkey2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={turkey2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Turkey" ? (
        <div id="turkey3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={turkey3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Azerbaijan" ? (
        <div id="azerbaijan1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={azerbaijan1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Azerbaijan" ? (
        <div id="azerbaijan2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={azerbaijan2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Azerbaijan" ? (
        <div id="azerbaijan3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={azerbaijan3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Europe" ? (
        <div id="europe1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={europe1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Europe" ? (
        <div id="europe2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={europe2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Europe" ? (
        <div id="europe3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={europe3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kazakhstan" ? (
        <div id="kazakhstan1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kazakhstan1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kazakhstan" ? (
        <div id="kazakhstan2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kazakhstan2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kazakhstan" ? (
        <div id="kazakhstan3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kazakhstan3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Hong Kong" ? (
        <div id="hongkong1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={hongkong1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Hong Kong" ? (
        <div id="hongkong2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={hongkong2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Hong Kong" ? (
        <div id="hongkong3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={hongkong3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Malaysia" ? (
        <div id="malaysia1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={malaysia1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Malaysia" ? (
        <div id="malaysia2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={malaysia2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Malaysia" ? (
        <div id="malaysia3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={malaysia3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Georgia" ? (
        <div id="georgia1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={georgia1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Georgia" ? (
        <div id="georgia2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={georgia2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Georgia" ? (
        <div id="georgia3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={georgia3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kerala" ? (
        <div id="kerala1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kerala1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kerala" ? (
        <div id="kerala2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kerala2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kerala" ? (
        <div id="kerala3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kerala3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Andaman" ? (
        <div id="andaman1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={andaman1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Andaman" ? (
        <div id="andaman2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={andaman2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Andaman" ? (
        <div id="andaman3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={andaman3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Goa" ? (
        <div id="goa1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={goa1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Goa" ? (
        <div id="goa2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={goa2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Goa" ? (
        <div id="goa3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={goa3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Rajasthan" ? (
        <div id="rajasthan1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={rajasthan1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Rajasthan" ? (
        <div id="rajasthan2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={rajasthan2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Rajasthan" ? (
        <div id="rajasthan3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={rajasthan3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kashmir" ? (
        <div id="kashmir1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kashmir1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kashmir" ? (
        <div id="kashmir2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kashmir2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Kashmir" ? (
        <div id="kashmir3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={kashmir3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Ladakh" ? (
        <div id="ladakh1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={ladakh1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Ladakh" ? (
        <div id="ladakh2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={ladakh2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Ladakh" ? (
        <div id="ladakh3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={ladakh3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Sikkim-Darjeeling" ? (
        <div id="sgd1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={sikkim1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Sikkim-Darjeeling" ? (
        <div id="sgd2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={sikkim2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Sikkim-Darjeeling" ? (
        <div id="sgd3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={sikkim3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Himachal" ? (
        <div id="himachal1">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={himachal1}
            width="795"
            alt="quote header"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Himachal" ? (
        <div id="himachal2">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={himachal2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Himachal" ? (
        <div id="himachal3">
          <img
            onClick={() => console.log("abc")}
            //src={header2}
            src={himachal3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Maldives" ? (
        <div id="maldives1">
          <img
            onClick={() => console.log("MLE")}
            //src={header2}
            src={maldives1}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Maldives" ? (
        <div id="maldives2">
          <img
            onClick={() => console.log("MLE")}
            //src={header2}
            src={maldives2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Maldives" ? (
        <div id="maldives3">
          <img
            onClick={() => console.log("MLE")}
            //src={header2}
            src={maldives3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Vietnam" ? (
        <div id="vietnam1">
          <img
            onClick={() => console.log("MLE")}
            //src={header2}
            src={vietnam1}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Vietnam" ? (
        <div id="vietnam2">
          <img
            onClick={() => console.log("MLE")}
            //src={header2}
            src={vietnam2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Vietnam" ? (
        <div id="vietnam3">
          <img
            onClick={() => console.log("MLE")}
            //src={header2}
            src={vietnam3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Sri Lanka" ? (
        <div id="sl1">
          <img
            onClick={() => console.log("CMB")}
            //src={header2}
            src={srilanka1}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Sri Lanka" ? (
        <div id="sl2">
          <img
            onClick={() => console.log("CMB")}
            //src={header2}
            src={srilanka2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Sri Lanka" ? (
        <div id="sl3">
          <img
            onClick={() => console.log("CMB")}
            //src={header2}
            src={srilanka3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Mauritius" ? (
        <div id="mauritius1">
          <img
            onClick={() => console.log("MUR")}
            //src={header2}
            src={mauritius1}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Mauritius" ? (
        <div id="mauritius2">
          <img
            onClick={() => console.log("MUR")}
            //src={header2}
            src={mauritius2}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
      {quoteData.primary_destination == "Mauritius" ? (
        <div id="mauritius3">
          <img
            onClick={() => console.log("MUR")}
            //src={header2}
            src={mauritius3}
            width="795"
            alt="quote body"
          ></img>
        </div>
      ) : (
        ""
      )}
    </div>
    </div>
  );
};

export default Viewquote;
